<template>
  <div class="pos-container">
    <div id="v-idle" style="display: none">
      <!-- :duration in seconds-->
      <v-idle
        @idle="onIdlePOS"
        :events="['mousemove', 'keypress', 'ontouchstart', 'onclick']"
        :loop="true"
        :duration="get_pos_lock_screen_time * 60"
      />
    </div>

    <PosHeader
      :section="section"
      :selectedFilterName="selectedFilterName"
      :onChangeFilter="onChangeFilter"
      :onClickCloseButton="onClickCloseButton"
      :onClickHandler="onClickCall"
    />
    <!-- {{
      section
    }}-->
    <section class="pos-center-view">
      <div class="row h-100">
        <div
          :class="
            section.movieDetail || fullscreen
              ? 'col-12'
              : 'col-lg-8 col-xl-9 col-md-8 col-sm-8'
          "
        >
          <!-- POS MOVIE LISTING -->
          <div v-if="section.movieDetail" class="pos-movie-listing-wrapper">
            <!-- SELECT FORMAT MODAL -->
            <b-modal
              ref="selectFormat"
              id="selectFormat"
              size="lg"
              :title="$t('Filters')"
              centered
              hide-footer
            >
              <!-- <button class="btn-modal-close" v-on:click="onCloseModal('selectFormat')">&times;</button> -->
              <h6>Formats</h6>
              <div class="row h-100 pt-2">
                <div
                  v-for="(format, formatKey) in getMovieFormats"
                  :key="formatKey"
                  v-on:click="onClickFilter($event, format)"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieFormatFilter == format.mf_id
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ format.mf_name }}
                  </button>
                </div>
                <div
                  v-on:click="selectedMovieFormatFilter = null"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieFormatFilter == null
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ $t("all") }}
                  </button>
                </div>
                <!-- <div class="col-md-4 text-center">
              <button class="btn-outline-blue-lg mb-3">3D</button>
            </div>
            <div class="col-md-4 text-center">
              <button class="btn-outline-blue-lg mb-3">4D</button>
            </div>
            <div class="col-md-4 text-center">
              <button class="btn-outline-blue-lg mb-3">IMAX 3D</button>
            </div>
            <div class="col-md-4 text-center">
              <button class="btn-outline-blue-lg mb-3">4DX</button>
            </div>
            <div class="col-md-4 text-center">
              <button class="btn-outline-blue-lg mb-3">IMAX 4D</button>
                </div>-->
              </div>

              <h6 class="mt-3">Languages</h6>
              <div class="row h-100 pt-2">
                <div
                  v-for="(lang, LangKey) in getMovieLanguages"
                  :key="LangKey"
                  v-on:click="selectedMovieLanguageFilter = lang.lang_id"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieLanguageFilter == lang.lang_id
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ lang.lang_name }}
                  </button>
                </div>
                <div
                  v-on:click="selectedMovieLanguageFilter = null"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieLanguageFilter == null
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ $t("all") }}
                  </button>
                </div>
              </div>

              <h6 class="mt-3">Genre</h6>
              <div class="row h-100 pt-2">
                <div
                  v-for="(genre, genreKey) in getMovieGenres"
                  :key="genreKey"
                  v-on:click="selectedMovieGenreFilter = genre.genre_id"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieGenreFilter == genre.genre_id
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ genre.g_name }}
                  </button>
                </div>
                <div
                  v-on:click="selectedMovieGenreFilter = null"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieGenreFilter == null
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ $t("all") }}
                  </button>
                </div>
              </div>

              <div class="text-center">
                <button
                  class="btn-blue-lg my-3 text-center"
                  @click="applyFilters()"
                >
                  {{ $t("Apply") }}
                </button>
              </div>
            </b-modal>

            <!-- LISTED MOVIE SYNOPSIS MODAL -->
            <b-modal
              ref="movieSynopsis"
              id="listed-movie-synopsis"
              size="lg"
              centered
              modal-lg
              hide-header
              hide-footer
            >
              <div class="row">
                <div class="col-md-5">
                  <img
                    v-lazy="
                    getLangSpecificAttribute(
                      movieDetails.MovieContent,
                      AREA_LANG_ID,
                      'artwork_image'
                    )
                  "
                    class="img-fluid w-100 rounded-10"
                  />
                </div>
                <div class="col-md-7">
                  <div class="row mr-0">
                    <div class="col-12 border-bottom">
                      <div class="row">
                        <div class="col-md-10 d-flex align-items-center">
                          <h5 class="font-weight-bold mb-0">
                            {{ movieDetails.mc_title }}
                          </h5>
                        </div>
                        <div class="col-md-2">
                          <button
                            class="btn-modal-close pos-modal-close"
                            v-on:click="onCloseModal('movieSynopsis')"
                          >
                            &times;
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("release") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.mrrdr_release_date | dateparse }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $tc("language", 1) }}
                        </div>
                        <div class="col-8">{{ movieDetails.lang_name }}</div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("rating") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.rating }}&nbsp;&nbsp;
                          <span v-if="movieDetails.earliest_bday" class=""
                            >({{ $t("earliest_bday") }}:
                            {{ movieDetails.earliest_bday }})</span
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $tc("format", 1) }}
                        </div>
                        <div class="col-8">
                          <span>{{ movieDetails.mf_name }}</span>
                          <!-- <span>|</span>
                      <span>3D</span>
                      <span>|</span>
                          <span>4D</span>-->
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("soundformat") }}
                        </div>
                        <div class="col-8">
                          <span>{{ movieDetails.sound_format_name }}</span>

                          <!-- <span>|</span>
                      <span>3D</span>
                      <span>|</span>
                          <span>4D</span>-->
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("running") }} {{ $t("time") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.mrrdr_runtime }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $tc("genre", 1) }}
                        </div>
                        <div class="col-8">
                          <!-- movieDetails.g_name.toString() -->
                          {{
                            movieDetails.g_name &&
                              movieDetails.g_name.join(", ")
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("castCrew") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.movie_cast_crew }}
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-12 py-2 border-bottom"
                      v-if="
                        movieDetails.movie_production &&
                          movieDetails.movie_production.length > 0
                      "
                    >
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("production") }}
                        </div>
                        <div class="col-8">
                          {{
                            movieDetails.movie_production &&
                            movieDetails.movie_production.length > 0
                              ? movieDetails.movie_production
                                  .map(x => x.production_name)
                                  .toString()
                              : ""
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("synopsis") }}
                        </div>
                        <div class="col-8">
                          {{
                            getLangSpecificAttribute(
                              movieDetails.MovieContent,
                              AREA_LANG_ID,
                              "mc_plot"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 py-2 text-center fs-12">
                  <p class="text-muted">
                    {{ $t("showing_content_in_language") }}:
                    <b-dropdown
                      right
                      variant="pos-dropdown"
                      class="mr-3 al_dropdown"
                    >
                      <template v-slot:button-content class="text-primary">
                        <img
                          src="@/assets/img/icons/language-icon.svg"
                          height="25px"
                          width="25px"
                        />
                        <span class="text-primary">{{
                          selectedContentLang.lang_name
                        }}</span>
                      </template>
                      <div>
                        <b-dropdown-item
                          v-for="(lang, langIndex) in CONTENT_LANG_ARRAY"
                          :key="langIndex"
                          @click="onChangeAreaLanguage(lang)"
                          >{{ lang.lang_name }}</b-dropdown-item
                        >
                      </div>
                    </b-dropdown>
                  </p>
                </div>
              </div>
            </b-modal>

            <!-- AVAILABLE, FILLING-FAST, SOLD-OUT -->
            <!-- <b-tabs
              ref="showTabs"
              @input="onChangeTab($event)"
              nav-wrapper-class="movie-view-type-selector"
              content-class="mt-3"
            > -->
            <!-- FILTER BY MOVIE SECTION -->
            <!-- <b-tab :title="$tc('movie', 1)">
              </b-tab> -->

            <!-- FILTER BY DATE SELECTION SLIDER -->
            <!-- <b-tab :title="$t('date')" active>
              </b-tab> -->

            <!-- FILTER BY SCREEN SECTION  -->
            <!-- <b-tab :title="$tc('screen', 1)">
              </b-tab> -->

            <!-- FILTER BY LANGUAGE SECTION -->
            <!-- <b-tab :title="$tc('language', 1)">
              </b-tab> -->
            <!-- </b-tabs> -->

            <div class="pos_movie_search_n_filters">
              <!--Down Filter---->
              <section
                class="pos_movie_search_n_filters__nav"
                style="display:none"
              >
                <article class="movie_view_type_selector_new">
                  <!-- FILTER BY MOVIE SECTION -->
                  <span
                    @click="onChangeFilter($event, 'movie')"
                    :class="selectedFilterName === 'movie' ? 'active' : ''"
                  >
                    {{ $tc("movie", 1) }}
                  </span>

                  <!-- FILTER BY DATE SELECTION SLIDER -->
                  <span
                    @click="onChangeFilter($event, 'date')"
                    :class="selectedFilterName === 'date' ? 'active' : ''"
                  >
                    {{ $t("date") }}
                  </span>

                  <!-- FILTER BY SCREEN SECTION  -->
                  <span
                    @click="onChangeFilter($event, 'screen')"
                    :class="selectedFilterName === 'screen' ? 'active' : ''"
                  >
                    {{ $tc("screen", 1) }}
                  </span>

                  <!-- FILTER BY LANGUAGE SECTION -->
                  <span
                    @click="onChangeFilter($event, 'language')"
                    :class="selectedFilterName === 'language' ? 'active' : ''"
                  >
                    {{ $tc("language", 1) }}
                  </span>
                </article>
                <div class="search-input mx-3">
                  <b-form-input
                    v-debounce:300="onSearch"
                    v-model="searchValue"
                    placeholder="Search for movie by Name"
                    type="search"
                    @search="onSearch()"
                  ></b-form-input>
                  <!-- <input type="search" placeholder="Search..." class="form-control" /> -->
                </div>
                <button class="btn-blue-lg" v-b-modal.selectFormat>
                  {{ $tc("Filters") }}
                </button>
              </section>

              <PosDateSlider
                :onChangeTab="onChangeFilter"
                :selectedTabIndex="selectedTabIndex"
                :dateSelectionSlider="silderOne"
                :childComponents="childComponents"
              />

              <section class="pos_movie_search_n_filters__content">
                <!-- tab one -->
                <!-- <PosDateSlider
                  :onChangeTab="onChangeTab"
                  :selectedTabIndex="selectedTabIndex"
                  :dateSelectionSlider="silderOne"
                  :childComponents="childComponents"
                /> -->

                <!-- if movie -->
                <div v-if="selectedFilterName === 'movie'">
                  <div v-if="isDataLoading" class="pos-no-schedule">
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/img/icons/loading.svg"
                          height="75"
                          width="75"
                        />
                      </div>
                      <br />
                      <h6>Fetching Shows...Please Wait</h6>
                    </div>
                  </div>

                  <div
                    v-if="!isDataLoading && visibleShowsDates.length == 0"
                    class="pos-no-schedule"
                  >
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/img/icons/no-schedule.svg"
                          height="75"
                          width="75"
                        />
                      </div>
                      <br />
                      <h6>No shows are scheduled for this date.</h6>
                    </div>
                  </div>

                  <div
                    class="movie-tab-wrapper"
                    v-if="visibleShowsDates.length > 0"
                  >
                    <div class="row" id="movie-list-visibleShowsDates">
                      <div
                        class="col-12 col-lg-12 col-md-12 col-sm-12"
                        v-for="(shows, showKey) in visibleShowsDates"
                        :key="showKey"
                      >
                        <div class="row">
                          <div
                            v-b-modal.listed-movie-synopsis
                            v-on:click="
                              onClickMovieModal(
                                shows[0].movie_id,
                                shows[0].md_id
                              )
                            "
                            class="col-lg-2 col-xl-2 col-md-2 col-sm-2 cursor-pointer"
                          >
                            <div class="img-hover">
                              <img
                                v-lazy="
                                  getLangSpecificAttribute(
                                    shows[0].altMovieContent,
                                    shows[0].lang_id,
                                    'artwork'
                                  )
                                "
                                class="rounded-10 img_height"
                              /><!--style="height:22vh;"-->
                            </div>
                          </div>
                          <div
                            class="col-sm-10 col-md-10 col-lg-10 col-xl-10 pl-0 pr-4"
                          >
                            <div class="w-100  pl-3 pt-3 bg-light rounded-10">
                              <!--h-100-->
                              <div class="d-flex align-items-center mb-lg-2">
                                <div class="mr-4 movie-name">
                                  {{ shows[0].movie_title }}
                                </div>
                                <span class="movie-rating">{{
                                  shows[0].rating
                                }}</span>
                              </div>

                              <div class="mb-lg-2">
                                <span class="mr-2">{{
                                  shows[0].lang_version ||
                                    shows[0].language_name
                                }}</span>
                                <span
                                  class="movie-format"
                                  v-if="shows[0].movie_format"
                                  >{{ shows[0].movie_format }}</span
                                >
                                &nbsp;
                                <span class="movie-runtime"
                                  >{{ shows[0].mrrdr_runtime }} Min</span
                                >
                              </div>

                              <!-- <div class="lh-1 text-blue mb-lg-2">{{shows[0].screen_name}}</div> -->
                              <!-- singleShow.ss_start_date_time < currentTime ? 'disabled':  -->
                              <div class="mr-3">
                                <ul class="listed-movie-time-list rounded">
                                  <li
                                    v-for="(singleShow,
                                    singleShowIndex) in getSortArrayHere(shows)"
                                    v-on:click="
                                      onClickShow(
                                        shows[singleShowIndex],
                                        singleShow
                                      )
                                    "
                                    :key="singleShowIndex"
                                    :class="
                                      allowPastBooking == 'Y'
                                        ? 'cursor-pointer available-button'
                                        : !timeSinceShowElapsed(
                                            singleShow.ss_start_show_time,
                                            singleShow.ss_actual_start_date,
                                            singleShow.cine_cutoff_time_in_mins
                                          )
                                        ? 'disabled'
                                        : singleShow.percentage_by_movie < 60
                                        ? 'cursor-pointer available-button'
                                        : singleShow.percentage_by_movie >=
                                            60 &&
                                          singleShow.percentage_by_movie <= 99
                                        ? 'cursor-pointer filling-fast-button'
                                        : singleShow.percentage_by_movie == 100
                                        ? 'house-full-button disabled'
                                        : ''
                                    "
                                  >
                                    {{
                                      moment(
                                        singleShow.ss_start_show_time,
                                        "HH:mm:ss"
                                      ).format("HH:mm")
                                    }}
                                  </li>
                                  <!-- singleShow.ss_start_date_time < currentTime ? 'disabled': -->
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="movie-card-seperator"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- tab two -->
                <!-- <PosDateSlider
                  :onChangeTab="onChangeTab"
                  :selectedTabIndex="selectedTabIndex"
                  :dateSelectionSlider="silderOne"
                  :childComponents="childComponents"
                /> -->

                <!-- if date -->
                <div v-if="selectedFilterName === 'date'">
                  <div
                    v-if="visibleShowsDates.length === 0"
                    class="pos-no-schedule"
                  >
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/img/icons/no-schedule.svg"
                          height="75"
                          width="75"
                        />
                      </div>
                      <br />
                      <h6>No shows are scheduled for this date.</h6>
                    </div>
                  </div>

                  <div class="movie-selection-container" v-else>
                    <div
                      class="movie-listing-card col-2"
                      v-for="(shows, showsKey) in visibleShowsDates"
                      :key="showsKey"
                    >
                      <div class="movie-listing-card-content" v-if="shows">
                        <!-- <div v-b-modal.listed-movie-synopsis> -->
                        <div
                          v-b-modal.listed-movie-synopsis
                          v-on:click="
                            onClickMovieModal(shows[0].movie_id, shows[0].md_id)
                          "
                          class="
                            listed-movie-detail-wrapper
                            cursor-pointer
                            img-hover
                          "
                        >
                          <img
                            v-lazy="
                              getLangSpecificAttribute(
                                shows[0].altMovieContent,
                                shows[0].lang_id,
                                'artwork'
                              )
                            "
                            class="img-fluid w-100"
                            style="height:24vh"
                          />
                          <div class="listed-movie-details 123">
                            <div class="d-flex">
                              <div class="w-75">
                                <div class="movie-name">
                                  {{ shows[0].movie_title }}
                                </div>
                              </div>
                              <div class="w-25 text-right">
                                <span class="movie-rating">{{
                                  shows[0].rating
                                }}</span>
                              </div>
                            </div>

                            <!-- <div>
                <div class="seats-available-status available position-static">
                  <span>Available</span>
                </div>
                          </div>-->

                            <div class="d-flex justify-content-evenly">
                              <div
                                class="w-100 mb-1 d-flex justify-content-between"
                              >
                                <div>
                                  <span class="mr-1">{{
                                    shows[0].lang_version ||
                                      shows[0].language_name
                                  }}</span>
                                  <span
                                    class="movie-format mr-1"
                                    v-if="shows[0].movie_format"
                                    >{{ shows[0].movie_format }}
                                  </span>
                                  <span
                                    v-if="shows[0].sound_format_name"
                                    class="movie-format"
                                  >
                                    {{ shows[0].sound_format_name }}</span
                                  >
                                  <span v-if="shows[0].movie_experience">{{
                                    shows[0].movie_experience
                                  }}</span>
                                  <span v-else></span>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <div
                                    class="text-blue ml-1"
                                    style="width:45px;white-space:nowrap;"
                                  >
                                    {{ shows[0].mrrdr_runtime }} Min
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ml-1">
                              <!-- <span
                                v-if="shows[0].movie_experience"
                                class="movie-format"
                                >{{ shows[0].movie_experience }}</span
                              >
                              <span v-else></span> -->
                            </div>
                            <div>
                              <ul class="listed-movie-time-list">
                                <!-- <li class="selected-show">2:30 PM</li> -->
                                <!-- :class="singleShow.ss_start_show_time < currentTime ? 'pointer-none':'cursor-pointer'" -->
                                <li
                                  v-for="(singleShow,
                                  singleShowIndex) in getSortArrayHere(shows)"
                                  v-on:click="
                                    onClickShow(
                                      shows[singleShowIndex],
                                      singleShow
                                    )
                                  "
                                  :key="singleShowIndex"
                                  :class="
                                    allowPastBooking == 'Y'
                                      ? 'cursor-pointer available-button'
                                      : !timeSinceShowElapsed(
                                          singleShow.ss_start_show_time,
                                          singleShow.ss_actual_start_date,
                                          singleShow.cine_cutoff_time_in_mins
                                        )
                                      ? 'disabled'
                                      : singleShow.percentage_by_movie < 60
                                      ? 'cursor-pointer available-button'
                                      : singleShow.percentage_by_movie >= 60 &&
                                        singleShow.percentage_by_movie <= 99
                                      ? 'cursor-pointer filling-fast-button'
                                      : singleShow.percentage_by_movie == 100
                                      ? 'house-full-button disabled'
                                      : ''
                                  "
                                >
                                  {{ singleShow.ss_start_show_time }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <!-- </div> -->
                      </div>

                      <!-- SHOW TIMING LIST -->
                    </div>
                  </div>
                </div>

                <!-- tab three -->

                <!-- DATE SELECTION SLIDER -->
                <!-- <PosDateSlider
                  :onChangeTab="onChangeTab"
                  :selectedTabIndex="selectedTabIndex"
                  :dateSelectionSlider="silderOne"
                  :childComponents="childComponents"
                /> -->

                <!-- if screen -->
                <div v-if="selectedFilterName === 'screen'">
                  <div
                    v-if="visibleShowsScreens.length == 0"
                    class="pos-no-schedule"
                  >
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/img/icons/no-schedule.svg"
                          height="75"
                          width="75"
                        />
                      </div>
                      <br />
                      <h6>No shows are scheduled for this date.</h6>
                    </div>
                  </div>

                  <div class="screen-tab-wrapper" v-else>
                    <div
                      class="w-100"
                      v-for="(screenShow, screenShowKey) in visibleShowsScreens"
                      :key="screenShowKey"
                    >
                      <h6 class="font-weight-bold" style="font-size: 18px">
                        {{ screenShow[0][0].screen_name}}
                      </h6>
                      <div class="row mx-0">
                        <div
                          class="movie-listing-card mb-4 cursor-pointer col-2"
                          v-for="(movie, movieKey) in screenShow"
                          :key="movieKey"
                        >
                          <div class="movie-listing-card-content">
                            <div
                              v-b-modal.listed-movie-synopsis
                              v-on:click="
                                onClickMovieModal(
                                  movie[0].movie_id,
                                  movie[0].md_id
                                )
                              "
                              class="listed-movie-detail-wrapper img-hover"
                            >
                              <img
                                v-lazy="
                                  getLangSpecificAttribute(
                                    movie[0].altMovieContent,
                                    movie[0].lang_id,
                                    'artwork'
                                  )
                                "
                                class="img-fluid"
                                style="height:24vh"
                              />
                              <!-- <img src="@/assets/img/pos/pos-test-3.jpg" class="img-fluid" /> -->
                              <div
                                class="listed-movie-details 456"
                                style="border-radius:0px;"
                              >
                                <div class="d-flex">
                                  <div class="w-75">
                                    <div class="movie-name">
                                      {{ movie[0].movie_title }}
                                    </div>
                                  </div>
                                  <div class="w-25 text-right">
                                    <span class="movie-rating">{{
                                      movie[0].rating
                                    }}</span>
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap">
                                  <div class="w-100 mb-1">
                                    <span class="mr-1">{{
                                      movie[0].lang_version ||
                                        movie[0].language_name
                                    }}</span>
                                    <span
                                      class="movie-format"
                                      v-if="movie[0].movie_format"
                                      >{{ movie[0].movie_format }}</span
                                    >
                                  </div>
                                  <div
                                    class="d-flex justify-content-between w-100"
                                  >
                                    <div class="text-blue">
                                      {{ movie[0].screen_name }}
                                    </div>
                                    <div class="text-blue">
                                      {{ movie[0].mrrdr_runtime }} Min
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <ul class="listed-movie-time-list">
                              <!-- <li class="selected-show">2:30 PM</li> -->
                              <!-- :class="showTime.ss_start_show_time < currentTime ? 'pointer-none':'cursor-pointer'" -->
                              <li
                                v-for="(showTime, showTimeKey) in movie"
                                :key="showTimeKey"
                                v-on:click="
                                  onClickShow(movie[showTimeKey], showTime)
                                "
                                :class="
                                  allowPastBooking == 'Y'
                                    ? 'cursor-pointer available-button'
                                    : !timeSinceShowElapsed(
                                        showTime.ss_start_show_time,
                                        showTime.ss_actual_start_date,
                                        showTime.cine_cutoff_time_in_mins
                                      )
                                    ? 'disabled'
                                    : showTime.percentage_by_movie < 60
                                    ? 'cursor-pointer available-button'
                                    : showTime.percentage_by_movie >= 60 &&
                                      showTime.percentage_by_movie <= 99
                                    ? 'cursor-pointer filling-fast-button'
                                    : showTime.percentage_by_movie == 100
                                    ? 'house-full-button disabled'
                                    : ''
                                "
                              >
                                {{ showTime.ss_start_show_time }}
                              </li>
                            </ul>
                          </div>

                          <!-- SHOW TIMING LIST -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- tab four -->
                <!-- DATE SELECTION SLIDER -->
                <!-- <PosDateSlider
                  :onChangeTab="onChangeTab"
                  :selectedTabIndex="selectedTabIndex"
                  :dateSelectionSlider="silderOne"
                  :childComponents="childComponents"
                /> -->

                <!-- if language -->
                <div v-if="selectedFilterName === 'language'">
                  <div
                    v-if="visibleShowsLanguage.length == 0"
                    class="pos-no-schedule"
                  >
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/img/icons/no-schedule.svg"
                          height="75"
                          width="75"
                        />
                      </div>
                      <br />
                      <h6>No shows are scheduled for this date.</h6>
                    </div>
                  </div>

                  <div class="language-tab-wrapper" v-else>
                    <div
                      class="w-100"
                      v-for="(lang, langKey) in visibleShowsLanguage"
                      :key="langKey"
                    >
                      <h6 class="font-weight-bold" style="font-size: 18px">
                        {{ lang[0][0].language_name }}
                      </h6>

                      <div class="row mx-0">
                        <div
                          v-b-modal.listed-movie-synopsis
                          class="movie-listing-card mb-4 cursor-pointer col-2"
                          v-for="(movie, movieKey) in lang"
                          :key="movieKey"
                        >
                          <div class="movie-listing-card-content">
                            <div
                              v-b-modal.listed-movie-synopsis
                              v-on:click="
                                onClickMovieModal(
                                  lang[0][0].movie_id,
                                  lang[0][0].md_id
                                )
                              "
                              class="listed-movie-detail-wrapper img-hover"
                            >
                              <img
                                v-lazy="
                                  getLangSpecificAttribute(
                                    movie[0].altMovieContent,
                                    movie[0].lang_id,
                                    'artwork'
                                  )
                                "
                                class="img-fluid"
                                style="height:24vh"
                              />
                              <div
                                class="listed-movie-details 789"
                                style="border-radius:0px;"
                              >
                                <div class="d-flex">
                                  <div class="w-75">
                                    <div class="movie-name">
                                      {{ movie[0].movie_title }}
                                    </div>
                                  </div>
                                  <div class="w-25 text-right">
                                    <span class="movie-rating">{{
                                      movie[0].rating
                                    }}</span>
                                  </div>
                                </div>

                                <!-- <div>
            <div class="seats-available-status available position-static">
              <span>Available</span>
            </div>
                              </div>-->

                                <div class="d-flex flex-wrap">
                                  <div class="w-100 mb-1">
                                    <span class="mr-1">{{
                                      movie[0].lang_version ||
                                        movie[0].language_name
                                    }}</span>
                                    <span
                                      class="movie-format"
                                      v-if="movie[0].movie_format"
                                      >{{ movie[0].movie_format }}</span
                                    >
                                  </div>
                                  <div
                                    class="d-flex justify-content-between w-100"
                                  >
                                    <!-- <div class="text-blue">
                                    {{ movie[0].screen_name?movie[0].screen_name:"-" }}
                                  </div> -->
                                    <div class="text-blue">
                                      {{ movie[0].mrrdr_runtime }} Min
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <ul class="listed-movie-time-list">
                              <!-- <li class="selected-show">2:30 PM</li> -->
                              <!-- :class="showTime.ss_start_show_time < currentTime ? 'pointer-none':'cursor-pointer'" -->
                              <li
                                v-for="(showTime, showTimeKey) in movie"
                                :key="showTimeKey"
                                v-on:click="
                                  onClickShow(movie[showTimeKey], showTime)
                                "
                                :class="
                                  allowPastBooking == 'Y'
                                    ? 'cursor-pointer available-button'
                                    : !timeSinceShowElapsed(
                                        showTime.ss_start_show_time,
                                        showTime.ss_actual_start_date,
                                        showTime.cine_cutoff_time_in_mins
                                      )
                                    ? 'disabled'
                                    : showTime.percentage_by_movie < 60
                                    ? 'cursor-pointer available-button'
                                    : showTime.percentage_by_movie >= 60 &&
                                      showTime.percentage_by_movie <= 99
                                    ? 'cursor-pointer filling-fast-button'
                                    : showTime.percentage_by_movie == 100
                                    ? 'house-full-button disabled'
                                    : ''
                                "
                              >
                                {{ showTime.ss_start_show_time }}
                              </li>
                            </ul>
                          </div>

                          <!-- SHOW TIMING LIST -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <PosSeatLayout
            v-if="section.seatLayout"
            :showFullScreen="showFullScreen"
            :ss_id="selected_ssid"
            :reverse_screen="reverse_screen"
            :turnOffMultiSeatSelection="turnOffMultiSeatSelection"
          />
          <!-- POS CHECKOUT PAGE -->
          <div v-if="section.checkout" class="pos-checkout-wrapper">
            <div class="row h-100">
              <div class="col-lg-3 col-xl-3 pr-0">
                <button
                  v-for="(singlePaymentMode,
                  singlePaymentIndex) in paymentModesFiltered"
                  :key="singlePaymentIndex"
                  :disabled="machineDisplay.processing"
                  class="btn-paymentType"
                   :class="[
                      { 'active ': selectedPaymentMode.pm_id == singlePaymentMode.pm_id || (singlePaymentMode.pm_id == 'GiftCard' && giftCardPmIds.includes(String(selectedPaymentMode.pm_id))) },
                      { ' pm_disbaled ': machineDisplay.processing }
                    ]"
                  v-if="
                    isCashCardTransaction ? singlePaymentMode.pm_id != 13 : checkPaymentModeToShow(singlePaymentMode)
                  "
                  v-on:click="onSelectPaymentType(singlePaymentMode)"
                >
                  {{ singlePaymentMode.pm_payment_mode }}
                </button>
              </div>
              <div class="col-lg-9 col-xl-9">
                <div
                  class="cash-payment-container"
                  :class="
                    selectedPaymentMode.pm_id == 1
                      ? 'border-top-left-radius-0'
                      : ''
                  "
                  v-if="selectedPaymentMode.pm_id == 1"
                >
                  <PosCalculator class="mx-auto" />
                  <div class="mx-auto text-center" v-if="false">
                    <button class="btn-blue-lg px-4 w-50" @click="onClickPay()">
                      {{ $t("print") }} {{ $t("of") }}
                      {{
                        currFormat(
                          parseFloat(totalAmount) -
                            parseFloat(getloyaltyAmount)
                        )
                      }}
                      {{ currencyData.curr_code }}
                    </button>
                  </div>

                  <div
                    class="mx-auto text-center"
                    v-if="getOffersCollection.filter(x => checkOfferType(x)) && getOffersCollection.filter(x => checkOfferType(x)).length > 0"
                  >
                    <div
                      v-if="checkOpenOfferModal()"
                      class="fs-16 text-primary font-weight-bold"
                      @click="showNewOffersPopup()"
                    >
                      ({{
                        getOffersCollection.filter(x => checkOfferType(x))
                          .length
                      }})&nbsp; Offer(s) Available
                    </div>
                  </div>
                </div>

                <div
                  class="card-payment-contianer dasdasdasdas"
                  v-if="
                    selectedPaymentMode.pm_id == 2 ||
                      selectedPaymentMode.pm_id == 3
                  "
                >
                  <h6 class="mb-3">
                    {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
                  </h6>
                  <form>
                    <input
                      type="text"
                      disabled
                      :value="
                        parseFloat(totalAmount - getloyaltyAmount).toFixed(2) +
                          ' ' +
                          currencyData.curr_code
                      "
                      placeholder="Amount"
                    />
                  </form>
                  <img
                    src="@/assets/img/pos/card-payment.png"
                    height="100"
                    width="145"
                    class="mx-auto d-block mt-5"
                  />

                  <div
                    class="row d-flex justify-content-center mt-1"
                    v-if="USE_TIM_INTEGRATION == 'Y'"
                  >
                    <div class="machine-display">
                      <!-- <span>
                        {{machineDisplay.displayText}}
                      </span> -->
                      <div>
                        <b-spinner
                          v-if="machineDisplay.processing"
                          label="Processing..."
                          class="translate-spinner"
                        ></b-spinner>
                      </div>
                      <div v-if="machineDisplay.processing">Processing...</div>
                      <div
                        v-if="
                          timTimeObj.transactionTimeOut &&
                            machineDisplay.processing
                        "
                      >
                        Time Left:&nbsp;<span
                          class="font-weight-bold"
                          style="font-family: monospace;"
                          >{{ timTimeObj.transactionTimeOut }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="row d-flex justify-content-center mt-2"
                    v-if="USE_TIM_INTEGRATION == 'Y'"
                  >
                    <div
                      class="btn btn-primary"
                      :class="
                        machineDisplay.processing || parseFloat(totalAmount - getloyaltyAmount) < 0 ? 'disCreditPayBtn' : ''
                      "
                      :disabled="machineDisplay.processing || parseFloat(totalAmount - getloyaltyAmount) < 0"
                      @click="proceedCreditCard(1)"
                    >
                      Proceed
                      {{
                        parseFloat(totalAmount - getloyaltyAmount).toFixed(2)
                      }}&nbsp;{{ currencyData.curr_code }}
                    </div>
                  </div>
                  <div
                    class="row d-flex justify-content-center mt-1"
                    v-if="USE_NEOLEAP_POS_PAYMENT == 'Y'"
                  >
                    <div class="machine-display">
                      <div>
                        <b-spinner
                          v-if="machineDisplay.processing"
                          label="Processing..."
                          class="translate-spinner"
                        ></b-spinner>
                      </div>
                      <div v-if="machineDisplay.processing">Processing...</div>
                      <div
                        v-if="
                          neoLeapTimeObj.transactionTimeOut &&
                            machineDisplay.processing
                        "
                      >
                        Time Left:&nbsp;<span
                          class="font-weight-bold"
                          style="font-family: monospace;"
                          >{{ neoLeapTimeObj.transactionTimeOut }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="row d-flex justify-content-center mt-2"
                    v-if="USE_NEOLEAP_POS_PAYMENT == 'Y'"
                  >
                    <div
                      class="btn btn-primary"
                      :class="
                        machineDisplay.processing || parseFloat(totalAmount - getloyaltyAmount) < 0 ? 'disCreditPayBtn' : ''
                      "
                      :disabled="machineDisplay.processing || parseFloat(totalAmount - getloyaltyAmount) < 0"
                      @click="connectNeoLeap(1)"
                    >
                      Pay
                      {{
                        parseFloat(totalAmount - getloyaltyAmount).toFixed(2)
                      }}&nbsp;{{ currencyData.curr_code }}
                    </div>
                  </div>
                   <div class="hidden-manual-btns text-center mt-3" v-if="USE_NEOLEAP_POS_PAYMENT == 'Y' && skipNeoleapResponse == 'Y'">
                      <div class="btn btn-primary mr-2 btn_min_width_190" @click="proceedNeoleapManually(1)">
                        <span>Payment Captured</span>
                      </div>
                      <div class="btn btn-outline-primary btn_min_width_190" @click="cancelNeoleapManually(1)">
                        <span>Cancel</span>
                      </div>
                    </div>
                </div>

                <div
                  class="card-payment-contianer"
                  v-if="selectedPaymentMode.pm_id == 17"
                >
                  <h6 class="mb-3">
                    {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
                  </h6>
                  <form>
                    <input
                      type="text"
                      disabled
                      :value="
                        parseFloat(totalAmount - getloyaltyAmount).toFixed(2) +
                          ' ' +
                          currencyData.curr_code
                      "
                      placeholder="Amount"
                    />
                  </form>
                  <img
                    src="@/assets/img/icons/unpaid-reservation.svg"
                    height="120"
                    width="245"
                    class="mx-auto d-block mt-5 pl-4"
                  />
                  <div class="mx-auto text-center">
                    <button class="btn-blue mt-5 px-5" @click="onClickPay()">
                      {{ "Proceed" }}
                    </button>
                  </div>
                </div>

                <!-- <div
                  class="card-payment-contianer dasdasdasdas"
                  v-if="selectedPaymentMode.pm_id == 23"
                >
                <h6 class="mb-3">
                    {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
                  </h6>
                  <MeritGiftCardSection
                    :onClickAddMoney="onClickAddMoney"
                  />
                </div> -->

                 <div
                  class="card-payment-contianer"
                  v-if="giftCardPmIds.includes(String(selectedPaymentMode.pm_id))"
                >
                  <h6 class="mb-3">
                    {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
                  </h6>
                  <section class="border-bottom giftcard_input">
                     <MeritGiftCardSection
                        v-if="selectedPaymentMode.pm_id == 23"
                        :onClickAddMoney="onClickAddMoney"
                        :onPayByGiftCard="onPayByGiftCard"
                      />
                  </section>

                  <section class="row voucher_btn_row mt-3">
                        <article
                          class="col-4"
                          v-for="(gc,
                          gcIndex) in giftCardsPaymentModes"
                          :key="gcIndex"
                        >
                          <div
                            class="voucher_btn"
                            @click="onSelectPaymentType(gc)"
                            :class="
                              selectedPaymentMode.pm_id == gc.pm_id
                                ? 'active'
                                : ''
                            "
                          >
                            <div class="voucher_btn__name">
                              <p>
                                {{ gc.pm_payment_mode }}
                              </p>
                            </div>
                          </div>
                        </article>
                      </section>
                </div>

                <div
                  class="card-payment-contianer"
                  v-if="
                    selectedPaymentMode.pm_id == 12 ||
                      selectedPaymentMode.pm_id == 13
                  "
                >
                  <section class="row">
                    <div class="col-12 mb-5">
                      <div class="row pos_booking_input_material">
                        <div class="col-6 input-material">
                          <input
                            placeholder="Voucher Code"
                            type="text"
                            v-model="VoucherCodeDeounce"
                            @input="onInputVoucherCode($event)"
                            name="VoucherCodeDeounce"
                            id="VoucherCodeDeounce"
                            class="form-control is_active"
                            ref="voucherInput"
                            @click="
                              onClickInputHandler('showVoucherCodeKeyboard')
                            "
                          />
                          <label class="">{{ $t("VoucherCodeDeounce") }}</label>
                          <VkeyboardFloat
                            :ID="'VoucherCodeDeounce'"
                            :onClickFun="
                              () => {
                                Object.keys(keyboardsVisible).map(x => {
                                  if (x == 'showVoucherCodeKeyboard') {
                                    keyboardsVisible[x] = !keyboardsVisible[x];
                                  } else {
                                    keyboardsVisible[x] = false;
                                  }
                                });
                              }
                            "
                          />
                          <Vkeyboard
                            :inputName="'VoucherCodeDeounce'"
                            :showOrHide="
                              keyboardsVisible.showVoucherCodeKeyboard
                            "
                            :initialValue="VoucherCodeDeounce"
                            @onChangeEvent="() => {}"
                            @onKeyEnter="onInputVoucherCode"
                            @changeKeyboardInput="VoucherCodeDeounce = $event"
                            @onClickClose="
                              () => {
                                keyboardsVisible.showVoucherCodeKeyboard = false;
                              }
                            "
                          />
                        </div>

                        <div class="col-6 input-material">
                          <input
                            placeholder="Comment"
                            type="text"
                            :value="getTransactionComment"
                            @input="onInputComment($event)"
                            name="voucherComment"
                            id="voucherComment"
                            class="form-control is_active"
                            @click="onClickInputHandler('showCommentKeyboard')"
                          />
                          <label class="">{{ "Enter Comment" }}</label>
                          <VkeyboardFloat
                            :ID="'voucherComment'"
                            :onClickFun="
                              () => {
                                Object.keys(keyboardsVisible).map(x => {
                                  if (x == 'showCommentKeyboard') {
                                    keyboardsVisible[x] = !keyboardsVisible[x];
                                  } else {
                                    keyboardsVisible[x] = false;
                                  }
                                });
                              }
                            "
                          />
                          <Vkeyboard
                            :inputName="'voucherComment'"
                            :showOrHide="keyboardsVisible.showCommentKeyboard"
                            :initialValue="getTransactionComment"
                            @onChangeEvent="() => {}"
                            @onKeyEnter="
                              () => {
                                keyboardsVisible.showCommentKeyboard = false;
                              }
                            "
                            @changeKeyboardInput="
                              onInputComment({
                                target: {
                                  value: $event
                                }
                              })
                            "
                            @onClickClose="
                              () => {
                                keyboardsVisible.showCommentKeyboard = false;
                              }
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <article class="col-md-12 col-lg-12 col-xl-8">
                      <section class="row voucher_btn_row">
                        <article
                          class="col-6"
                          v-for="(OffersVoucherItem,
                          OffersVoucherIndex) in getOffersVoucherCollection"
                          :key="OffersVoucherIndex"
                          v-if="
                            OffersVoucherItem.is_open_voucher == 'Y' &&
                              OffersVoucherItem.vs_redeem_at_boxoffice == 'Y' &&
                              ((OffersVoucherItem.is_complemetory_ticket ==
                                'Y' &&
                                OffersVoucherItem.tt_id) ||
                                (OffersVoucherItem.is_complemetory_ticket ==
                                  'N' &&
                                  !OffersVoucherItem.tt_id))
                          "
                        >
                          <div
                            class="voucher_btn"
                            @click="onApplyVoucherBox(OffersVoucherItem)"
                            :class="
                              offerApplied
                                ? offerApplied.voucher_code ==
                                  OffersVoucherItem.voucher_code
                                  ? 'active'
                                  : (getTicketTypePrice(OffersVoucherItem) &&
                                      OffersVoucherItem.tt_id) ||
                                    !OffersVoucherItem.tt_id
                                  ? ''
                                  : 'inactive'
                                : (getTicketTypePrice(OffersVoucherItem) &&
                                    OffersVoucherItem.tt_id) ||
                                  !OffersVoucherItem.tt_id
                                ? ''
                                : 'inactive'
                            "
                          >
                            <div class="voucher_btn__name">
                              <p>
                                {{ OffersVoucherItem.voucher_title }}
                              </p>
                            </div>
                            <div class="voucher_btn__details">
                              <!-- <p class="voucher_btn__screen">Saal 2</p> -->
                              <div
                                class="voucher_btn__time"
                                v-if="getTicketTypePrice(OffersVoucherItem)"
                              >
                                <p>
                                  {{ getTicketTypePrice(OffersVoucherItem) }}
                                  {{ currencyData.curr_code }}
                                </p>
                              </div>
                              <div
                                class="voucher_btn__screen"
                                v-if="
                                  !(
                                    (getTicketTypePrice(OffersVoucherItem) &&
                                      OffersVoucherItem.tt_id) ||
                                    !OffersVoucherItem.tt_id
                                  )
                                "
                              >
                                <p>({{ $t("voucher_not_available") }})</p>
                              </div>
                            </div>
                          </div>
                        </article>
                        <article class="col-12">
                          <section class="row">
                            <article class="col-6">
                              <div
                                class="voucher_btn"
                                v-b-modal.pos-applicable-offers
                                @click="fetchOffersVouchersList"
                              >
                                <div class="voucher_btn__name">
                                  <p>View Offers</p>
                                </div>
                                <!-- <div class="voucher_btn__details"> -->
                                <!-- <div class="voucher_btn__screen">
                            <p>
                              Saal 2
                            </p>
                          </div>
                          <div class="voucher_btn__time">
                            <p>
                              18:00
                            </p>
                            </div> -->
                                <!-- </div> -->
                              </div>
                            </article>
                          </section>
                        </article>
                      </section>
                    </article>
                  </section>
                  <section class="row"></section>
                  <!-- IN PROGRESS -->
                </div>

                <div
                  class="card-payment-contianer"
                  :class="
                    selectedPaymentMode.pm_id == 11
                      ? 'border-top-left-radius-0'
                      : ''
                  "
                  v-if="selectedPaymentMode.pm_id == 11"
                >
                  <h6 class="mb-3">
                    {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
                  </h6>
                  <h6 class="mb-3">
                    {{ $t("mobileno") }} : {{ customer_mobile_number }}
                  </h6>
                  <h6 class="mb-3">
                    {{ $t("emailaddress") }} : {{ email_address }}
                  </h6>
                  <h6 class="mb-3">
                    {{ $t("full") }} {{ $t("name") }} : {{ first_name }}
                    {{ last_name }}
                  </h6>
                  <div v-if="false" class="dropdown-curve-container">
                    <label
                      :class="
                        selectedCashCard &&
                        selectedCashCard.cash_card_number.length > 0
                          ? 'shift-up'
                          : ''
                      "
                      >Select Cash Card</label
                    >
                    <!-- Old Design -->
                    <b-dropdown
                      :text="
                        selectedCashCard
                          ? selectedCashCard.cash_card_number
                          : ''
                      "
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(card, cardIndex) in cashCards"
                        href="#"
                        :key="cardIndex"
                        name="cashCardDropdown"
                        id="cashCardDropdown"
                        v-on:click="selectCashCard(card)"
                        >{{ card.cash_card_number }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <div class="row mt-3" v-if="false">
                    <div class="col-6">
                      <h6 class>
                        Balance :
                        {{
                          parseFloat(
                            selectedCashCard.remaining_balance
                          ).toFixed(2)
                        }}
                      </h6>
                    </div>
                    <div
                      v-if="
                        selectedCashCard.remaining_balance && paidflag == false
                      "
                      class="col-6"
                    >
                      <button
                        :disabled="disablePayNow"
                        @click.prevent.stop="payCashCard()"
                        class="btn-blue"
                      >
                        {{ $t("Pay Now") }}
                      </button>
                    </div>
                  </div>

                  <!-- New Design -->
                  <CashCardPos
                    SectionType="debit"
                    :onClickAddMoney="onClickAddMoney"
                  />
                </div>

                <div
                  class="card-payment-contianer"
                  v-if="selectedPaymentMode.pm_id == 10"
                >
                  <h6 class="mb-3">
                    {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
                  </h6>
                  <h6 class="mb-3">
                    {{ $t("mobileno") }} : {{ customer_mobile_number }}
                  </h6>
                  <h6 class="mb-3">
                    {{ $t("emailaddress") }} : {{ email_address }}
                  </h6>
                  <h6 class="mb-3">
                    {{ $t("full") }} {{ $t("name") }} : {{ first_name }}
                    {{ last_name }}
                  </h6>

                  <form>
                    <label>Points Available</label>
                    <input
                      type="number"
                      disabled
                      :value="getAvailablePoints"
                      placeholder="Points Available"
                    />
                    <label>Burn Points</label>
                    <input
                      type="number"
                      disabled
                      :value="getBurnPoints"
                      placeholder="Burn Points"
                    />
                    <button
                      v-if="
                        getBurnPoints > 0 &&
                          !isLoyaltyApplied &&
                          Object.keys(offerApplied).length == 0
                      "
                      class="fs-14 btn-blue-lg mb-2 ml-3 mt-3"
                      v-on:click="onApplyLoyalty()"
                    >
                      {{ $t("Apply") }}
                    </button>
                  </form>
                </div>

                <div
                  class="cashless-payments-container"
                  v-if="
                    selectedPaymentMode.pm_id == 4 ||
                      selectedPaymentMode.pm_id == 5 ||
                      selectedPaymentMode.pm_id == 6 ||
                      selectedPaymentMode.pm_id == 7 ||
                      selectedPaymentMode.pm_id == 8
                  "
                >
                  <h6 class="mb-3">{{ $t("cashlessPayment") }}</h6>
                  <div class="row">
                    <div class="col-lg-6 col-xl-3">
                      <button class="btn-cashlessPayment">
                        <img
                          src="@/assets/img/pos/paymentTypes/applepay.png"
                          class="img-fluid"
                        />
                      </button>
                    </div>

                    <div class="col-lg-6 col-xl-3">
                      <button class="btn-cashlessPayment">
                        <img
                          src="@/assets/img/pos/paymentTypes/paypal.png"
                          height="auto"
                          width="80px"
                        />
                      </button>
                    </div>

                    <div class="col-lg-6 col-xl-3">
                      <button class="btn-cashlessPayment">
                        <img
                          src="@/assets/img/pos/paymentTypes/alipay.png"
                          height="auto"
                          width="100px"
                        />
                      </button>
                    </div>

                    <div class="col-lg-6 col-xl-3">
                      <button class="btn-cashlessPayment">
                        <img
                          src="@/assets/img/pos/paymentTypes/googlepay.png"
                          height="auto"
                          width="100px"
                        />
                      </button>
                    </div>

                    <div class="col-lg-6 col-xl-3">
                      <button class="btn-cashlessPayment">
                        <img
                          src="@/assets/img/pos/paymentTypes/samsungpay.png"
                          height="auto"
                          width="105px"
                        />
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  class="split-payment-container"
                  v-if="paymentTypes.splitPayments"
                >
                  <h6 class="mb-3">{{ $t("splitPayments") }}</h6>
                </div>

                <div
                  class="coupon-container"
                  v-if="paymentTypes.couponNPromotions"
                >
                  <h6 class="mb-3">{{ $t("couponPromotion") }}</h6>
                  <form>
                    <div class="row">
                      <div class="col-12 mb-4">
                        <input
                          type="text"
                          placeholder="Coupons / Promotion Number"
                        />
                      </div>
                    </div>
                  </form>
                </div>

                <div class="voucher-container" v-if="paymentTypes.vouchers">
                  <h6 class="mb-3">{{ $t("voucher") }}</h6>
                  <form>
                    <div class="row">
                      <div class="col-12 mb-4">
                        <input type="text" placeholder="Card Numbers" />
                      </div>
                      <div class="col-12 mb-4">
                        <input type="text" placeholder="Customer Name" />
                      </div>
                      <div class="col-12 mb-4">
                        <input
                          type="text"
                          placeholder="Card / Coupon / Voucher No"
                        />
                      </div>
                    </div>
                  </form>
                </div>

                <div class="loyalty-container" v-if="paymentTypes.loyaltyCard">
                  <h6 class="mb-3">{{ $t("loyaltyCard") }}</h6>
                  <form>
                    <div class="row">
                      <div class="col-12 mb-4">
                        <input type="text" placeholder="Card Numbers" />
                      </div>
                      <div class="col-12 mb-4">
                        <input type="text" placeholder="Customer Name" />
                      </div>
                      <div class="col-12 mb-4">
                        <input type="text" placeholder="Mobile No" />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div v-if="section.cashCardTopup" class="pos-checkout-wrapper">
            <div class="row h-100">
              <div class="col-lg-3 col-xl-3 pr-0">
                <button
                  v-for="(singlePaymentMode,
                  singlePaymentIndex) in paymentModes"
                  :key="singlePaymentIndex"
                  class="btn-paymentType"
                  :disabled="machineDisplay.processing"
                   :class="[
                      { 'active ': selectedPaymentMode.pm_id == singlePaymentMode.pm_id },
                      { ' pm_disbaled ': machineDisplay.processing }
                    ]"
                  v-on:click="onSelectPaymentType(singlePaymentMode)"
                  v-if="parseInt(singlePaymentMode.pm_id) < 4"
                >
                  {{ singlePaymentMode.pm_payment_mode }}
                </button>
              </div>
              <div class="col-lg-9 col-xl-9">
                <div
                  class="cash-payment-container"
                  :class="
                    selectedPaymentMode.pm_id == 1
                      ? 'border-top-left-radius-0'
                      : ''
                  "
                  v-if="selectedPaymentMode.pm_id == 1"
                >
                  <PosCalculator class="mx-auto" />
                  <div class="mx-auto text-center">
                    <button
                      class="btn-blue-lg px-4 w-50"
                      @click="checkTopUpCashInput()"
                    >
                      {{ $t("cash_card_topup") }}
                      {{ currFormat(cashCardTopupAmount.toFixed(2)) }}
                      {{ currencyData.curr_code }}
                    </button>
                  </div>
                </div>

                <div
                  class="card-payment-contianer dsdsad"
                  v-if="
                    selectedPaymentMode.pm_id == 2 ||
                      selectedPaymentMode.pm_id == 3
                  "
                >
                  <h6 class="mb-3">
                    {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
                  </h6>
                  <form>
                    <input
                      type="text"
                      disabled
                      :value="
                        parseFloat(cashCardTopupAmount).toFixed(2) +
                          ' ' +
                          currencyData.curr_code
                      "
                      placeholder="Amount"
                    />
                  </form>
                  <img
                    src="@/assets/img/pos/card-payment.png"
                    height="100"
                    width="145"
                    class="mx-auto d-block mt-5"
                  />
                  <div
                    class="row d-flex justify-content-center mt-5"
                    v-if="USE_TIM_INTEGRATION == 'Y'"
                  >
                    <div class="machine-display">
                      <!-- <span>
                        {{machineDisplay.displayText}}
                      </span> -->
                      <div>
                        <b-spinner
                          v-if="machineDisplay.processing"
                          label="Processing..."
                          class="translate-spinner"
                        ></b-spinner>
                      </div>
                      <div v-if="machineDisplay.processing">Processing...</div>
                      <div
                        v-if="
                          timTimeObj.transactionTimeOut &&
                            machineDisplay.processing
                        "
                      >
                        Time Left:&nbsp;<span
                          class="font-weight-bold"
                          style="font-family: monospace;"
                          >{{ timTimeObj.transactionTimeOut }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="row d-flex justify-content-center mt-2"
                    v-if="USE_TIM_INTEGRATION == 'Y'"
                  >
                    <div
                      class="btn btn-primary"
                      :class="
                        machineDisplay.processing ? 'disCreditPayBtn' : ''
                      "
                      :disabled="machineDisplay.processing"
                      @click="proceedCreditCard(2)"
                    >
                      Proceed
                      {{ parseFloat(cashCardTopupAmount).toFixed(2) }}&nbsp;{{
                        currencyData.curr_code
                      }}
                    </div>
                  </div>
                  <div
                    class="row d-flex justify-content-center mt-1"
                    v-if="USE_NEOLEAP_POS_PAYMENT == 'Y'"
                  >
                    <div class="machine-display">
                      <div>
                        <b-spinner
                          v-if="machineDisplay.processing"
                          label="Processing..."
                          class="translate-spinner"
                        ></b-spinner>
                      </div>
                      <div v-if="machineDisplay.processing">Processing...</div>
                       <div
                        v-if="
                          neoLeapTimeObj.transactionTimeOut &&
                            machineDisplay.processing
                        "
                      >
                        Time Left:&nbsp;<span
                          class="font-weight-bold"
                          style="font-family: monospace;"
                          >{{ neoLeapTimeObj.transactionTimeOut }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="row d-flex justify-content-center mt-2"
                    v-if="USE_NEOLEAP_POS_PAYMENT == 'Y'"
                  >
                    <div
                      class="btn btn-primary"
                      :class="
                        machineDisplay.processing ? 'disCreditPayBtn' : ''
                      "
                      :disabled="machineDisplay.processing"
                      @click="connectNeoLeap(2)"
                    >
                      Pay
                      {{ parseFloat(cashCardTopupAmount).toFixed(2) }}&nbsp;{{
                        currencyData.curr_code
                      }}
                    </div>
                  </div>
                   <div class="hidden-manual-btns text-center mt-3" v-if="USE_NEOLEAP_POS_PAYMENT == 'Y' && skipNeoleapResponse == 'Y'">
                      <div class="btn btn-primary mr-2 btn_min_width_190" @click="proceedNeoleapManually(2)">
                        <span>Payment Captured</span>
                      </div>
                      <div class="btn btn-outline-primary btn_min_width_190" @click="cancelNeoleapManually(2)">
                        <span>Cancel</span>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT DETAIL PANELS -->

        <div
          class="col-lg-3 col-xl-3 pl-0"
          v-if="section.cashCardTopup"
          :class="fullscreen ? 'd-none' : ''"
        >
          <div class="booking-details-box">
            <div class="col-12 border-bottom d-flex align-items-center">
              <h6 class="mb-0 py-2 text-black d-inline-block w-50">
                {{ $t("cash_card_topup") }}
              </h6>
            </div>

            <div class="booking-scroll-content">
              <div class="col-12" v-if="cashCardCustomerName">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $tc("customer", 1) }}</span>
                  </div>
                  <div class="col-7 px-0 overflow-hidden">
                    <strong>{{ cashCardCustomerName }} </strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{
                      $t("cash_card_number")
                    }}</span>
                  </div>
                  <div class="col-7 px-0 overflow-hidden">
                    <strong>{{
                      selectedTopUpCashCard.cash_card_number
                    }}</strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $t("cust_mobile") }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ cashCardCustMobileNumber }}</strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $t("cust_email") }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{
                      selectedTopUpCashCard.cust_email ||
                        custEmailCashCard ||
                        selectedTopUpCashCard.guest_email
                    }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <!-- TOTAL DIV -->
            <div class="col-12 border-top py-2" v-if="cashCardTopupAmount">
              <div class="row">
                <div class="col-5">
                  <h6 class="mb-0 font-weight-bold fs-18">Total</h6>
                </div>
                <div class="col-7 px-0">
                  <h6 class="font-weight-bold mb-0 fs-18 text-truncate">
                    {{ cashCardTopupAmount.toFixed(2) }}
                    {{ currencyData.curr_code }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-else-if="!section.movieDetail"
          class="col-lg-4 col-xl-3 pl-0 col-md-4 col-sm-4"
          :class="fullscreen ? 'd-none' : ''"
        >
          <div class="booking-details-box">
            <div class="col-12 border-bottom d-flex align-items-center py-2">
              <h6 class="mb-0 py-2 text-black d-inline-block w-50">
                {{ $t("booking") }} {{ $tc("details", 1) }}
              </h6>
              <!--class="btn-pos-view-offers"-->
              <div class="text-right d-inline-block w-50">
                <!-- <button
                  v-if="showViewOffers && checkCompleteRateCard"
                  class="btn-blue"
                  v-b-modal.pos-applicable-offers
                >
                  View Offers
                </button> -->
              </div>
            </div>

            <div class="booking-scroll-content" ref="rightSideContainer">
              <div class="col-12" v-if="getCustomerDetails.first_name">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $tc("customer", 1) }}</span>
                  </div>
                  <div class="col-7 px-0 overflow-hidden">
                    <strong
                      >{{ getCustomerDetails.first_name }}
                      {{ getCustomerDetails.last_name }}</strong
                    >
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $tc("movie", 1) }}</span>
                  </div>
                  <div class="col-7 px-0 overflow-hidden">
                    <strong>{{ showDetails.movie_title }}</strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $tc("language", 1) }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ showDetails.language_name }}</strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $tc("format", 1) }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ showDetails.movie_format }}</strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $t("soundformat") }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ showDetails.sound_format_name }}</strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $t("rating") }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ showDetails.rating }}</strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $t("age_limit") }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong
                      ><span
                        class="circle"
                        @click="getShowDetails(showDetails)"
                        >{{ showDetails.age_limit || 0 }}</span
                      >&nbsp;<span
                        v-if="showDetails.earliest_bday"
                        class="fs-12"
                        >({{ $t("earliest_bday") }}:
                        {{ showDetails.earliest_bday }})</span
                      ></strong
                    >
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $t("time") }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ showDetails.ss_start_show_time }}</strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $t("date") }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong> {{ showDetails.ss_start_date }}</strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $tc("screen", 1) }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ showDetails.screen_name }}</strong>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey"
                      >{{ $t("noof") }} {{ $tc("seat", 1) }}</span
                    >
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ selectedSeats.length }}</strong>
                  </div>
                </div>
              </div>

              <!-- <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey"
                      >{{ $tc("seat", 1) }} {{ $t("number") }}</span
                    >
                  </div>
                  <div class="col-7 px-0">
                    <ul class="pos-selected-seats-list">
                      <li
                        v-for="(seat, seatIndex) in selectedSeats"
                        :key="seatIndex"
                      >
                      <img :src="_GetImagePath(seat.srt_dash_image_url_selected)" height="20" width="20"/>
                        {{ seat.sl_seat_name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey"
                      >{{ $tc("seat", 1) }} {{ $t("number") }}</span
                    >
                  </div>
                  <div class="col-7 px-0">
                    <ul class="pos-selected-seats-list">
                      <div class="d-flex flex-wrap">
                      <li
                        v-for="(seatTypeGrp,
                        seatTypeGrpIndex) in groupedBySeatTypeSelectedSeats"
                        :key="seatTypeGrpIndex"
                      >
                        <span>
                          <img
                            :src="
                              _GetImagePath(
                                seatTypeGrp[1][0].srt_dash_image_url
                              )
                            "
                            height="20"
                            width="20"
                            class="pos-seat"
                            :style="{
                              borderColor: '#3876d2 !important',
                              backgroundColor: '#3876d2 !important',
                              zoom: '0.6 !important'
                            }"
                          />
                        </span>
                        <span  class="d-flex flex-wrap word-break">{{ seatTypeGrp[1].map(x => x.sl_seat_name).join(",") }}</span>
                        
                      </li>
                    </div>
                      <!-- <li
                        v-for="(seatTypeGrp, seatTypeGrpIndex) in groupedBySeatTypeSelectedSeats"
                        :key="seatTypeGrpIndex"
                      >
                      <img :src="_GetImagePath(seat.srt_dash_image_url_selected)" height="20" width="20"/>
                        {{ seat.sl_seat_name }}
                      </li> -->
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey"
                      >{{ $tc("seat", 1) }} {{ $t("class") }}</span
                    >
                  </div>
                  <div class="col-7 px-0">
                    <ul class="pos-selected-seats-list">
                      <li v-if="selectedSeats.length == 0">-</li>
                      <li v-if="selectedSeats.length > 0">
                        {{
                          Array.from(
                            new Set(
                              new Set(selectedSeats.map(x => x.sst_seat_type))
                            )
                          ).toString() || "-"
                        }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-12" v-if="checkCompleteRateCard">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $t("netAmount") }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong
                      >{{ (netTotal + rateCardAddonsNetAdd()).toFixed(2) }}
                      {{ currencyData.curr_code }}</strong
                    >
                  </div>
                </div>
              </div>

              <div v-if="isSwap" class="col-12">
                <div class="d-flex flex-wrap border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">Swap Discount</span>
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-between">
                      <strong class="d-block">
                        - {{ currFormat(getSwapTotalAmount) }}&nbsp;{{
                          currencyData.curr_code
                        }}</strong
                      >
                      <img
                        @click="onResetSwapInfo()"
                        class="d-table position-relative"
                        src="@/assets/img/icons/delete.svg"
                        height="20"
                        width="20"
                      />
                    </div>
                    <Tooltip
                      :title="`Swap Ticket Discount`"
                      :src="`question2.svg`"
                    />
                  </div>
                  <div class="col-12 pt-2 px-0">
                    <a class="text-blue viewSwap" @click="showSwapDetails()"
                      >View Swap Details</a
                    >
                  </div>
                  <div class="col-4 pr-0">
                    <div class="d-flex w-100 justify-content-between"></div>
                  </div>
                </div>
              </div>

              <div
                class="col-12"
                v-for="(charge, chargeKey) in additionalCharges"
                :key="chargeKey"
              >
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">{{ charge.ct_name }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong
                      >{{
                        charge.pas_is_rebate && charge.pas_is_rebate === "Y"
                          ? -(
                              charge.sp_value +
                              rateCardAddonsChargeTypeToAdd(
                                charge.charge_type_id
                              )
                            ).toFixed(2)
                          : (
                              charge.sp_value +
                              rateCardAddonsChargeTypeToAdd(
                                charge.charge_type_id
                              )
                            ).toFixed(2)
                      }}
                      {{ currencyData.curr_code }}</strong
                    >
                  </div>
                </div>
              </div>

              <!-- Rate card Addons -->

              <div class="col-12" v-if="RateCardAddonsChargesFinalAmount">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $t("addon_amount") }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong
                      >{{ RateCardAddonsChargesFinalAmount.toFixed(2) }}
                      {{ currencyData.curr_code }}</strong
                    >
                    <span
                      class="icon-collapse-up blue-icon mx-1 btn float-right"
                      style="height: 22px!important"
                      v-if="showAddonBreakup"
                      @click="onToggleAddonBreakup()"
                    ></span>
                    <span
                      class="icon-collapse blue-icon mx-1 btn float-right"
                      style="height: 22px!important"
                      v-if="!showAddonBreakup"
                      @click="onToggleAddonBreakup()"
                    ></span>
                  </div>
                </div>
              </div>
              <b-collapse v-model="showAddonBreakup" class="pb-2 px-4 fs-12">
                <div
                  v-if="RateCardAddonsChargesList.length > 0"
                  class="col-12"
                  v-for="(rac, racIndex) in RateCardAddonsChargesList"
                  :key="racIndex"
                >
                  <div class="d-flex border-bottom-lightgrey py-1">
                    <div class="col-5 pl-0">
                      <span class="text-lightgrey">{{ rac.addons_name }}</span>
                    </div>
                    <div class="col-7 px-0">
                      <strong
                        >{{ rac.final_price }}
                        {{ currencyData.curr_code }}</strong
                      >
                    </div>
                  </div>
                </div>
              </b-collapse>

              <!-- Rate card Addons End -->

              <div class="col-12" v-if="checkCompleteRateCard">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 px-0">
                    <span class="text-lightgrey">{{ $t("grossAmount") }}</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong
                      >{{ grossTotal.toFixed(2) }}
                      {{ currencyData.curr_code }}</strong
                    >
                  </div>
                </div>
              </div>

              <!-- PACKAGE TICKET -->
              <div
                v-if="SelectedFnbItemList && SelectedFnbItemList.length > 0"
                class="summary-content pt-3"
              >
                <div class="col-12">
                  <div class="row">
                    <div class="col-4">
                      <span class="text-lightgrey">Item</span>
                    </div>
                    <div class="col-4 px-0 text-center">
                      <span class="text-lightgrey">Qty</span>
                    </div>
                    <div class="col-4 text-right">
                      <span class="text-lightgrey mr-2">Price</span>
                    </div>
                  </div>
                </div>
                <div
                  class="col-12"
                  v-for="(orders, index) in SelectedFnbItemList"
                  :key="index"
                >
                  <div class="row align-items-center py-1">
                    <div class="col-4 pr-2">
                      <span class="font-weight-bold">{{
                        orders.item_name
                      }}</span>
                    </div>
                    <div
                      class="
                        col-4
                        px-0
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                    >
                      <strong>{{ orders.quantity }}</strong>
                    </div>
                    <div class="col-4">
                      <div
                        class="
                          d-flex
                          w-100
                          align-items-center
                          justify-content-end
                        "
                      >
                        <strong
                          >{{ currencyData.curr_code | uppercase }}&nbsp;{{
                            (orders.fp_total_amount * orders.quantity)
                              | RoundOff
                          }}</strong
                        >
                        <button
                          class="btn-pos-delete"
                          v-if="
                            orders.item_is_compulsory &&
                              orders.item_is_compulsory == 'N'
                          "
                          v-on:click="onRemoveFnBList({ index })"
                        ></button>
                      </div>
                    </div>
                  </div>
                  <hr class="my-0" />
                </div>
              </div>

              <div
                v-if="SelectedFnbItemList && SelectedFnbItemList.length > 0"
                class="col-12 py-1"
              >
                <div class="row">
                  <div class="col-4">
                    <span class="text-lightgrey">Sub Total</span>
                  </div>
                  <div class="col-8 text-right">
                    <strong
                      >{{ currencyData.curr_code | uppercase }} &nbsp;{{
                        selectedFnBItemsTotalPrice | RoundOff
                      }}</strong
                    >
                  </div>
                </div>
              </div>

              <div
                v-if="SelectedFnbItemList && SelectedFnbItemList.length > 0"
                class="col-12 py-1"
              >
                <div v-if="AdditionalTaxList.length === 0" class="row">
                  <div class="col-7">
                    <span class="text-lightgrey">Tax</span>
                  </div>
                  <div class="col-5 text-right">
                    <strong
                      >{{ currencyData.curr_code | uppercase }}&nbsp;0</strong
                    >
                  </div>
                </div>

                <div
                  v-if="AdditionalTaxList.length > 0"
                  v-for="(AdditionalTax,
                  AdditionalTaxIndex) in AdditionalTaxList"
                  :key="AdditionalTaxIndex"
                  class="row"
                >
                  <div class="col-7">
                    <span class="text-black">{{
                      AdditionalTax.ct_name | uppercase
                    }}</span>
                  </div>
                  <div class="col-5 text-right">
                    <strong
                      >{{ currencyData.curr_code | uppercase }}&nbsp;{{
                        AdditionalTax.totalTax | RoundOff
                      }}</strong
                    >
                  </div>
                </div>
              </div>

              <div
                v-if="
                  fnbTotal &&
                    SelectedFnbItemList &&
                    SelectedFnbItemList.length > 0
                "
                class="col-12 py-1"
              >
                <div class="row">
                  <div class="col-4 fw-500">
                    <span class="text-lightgrey">F&B Total</span>
                  </div>
                  <div class="col-8 text-right">
                    <strong
                      >{{ currencyData.curr_code | uppercase }} &nbsp;{{
                        currFormat(fnbTotal)
                      }}</strong
                    >
                  </div>
                </div>
              </div>

              <div
                v-if="offerApplied && Object.keys(offerApplied).length > 0"
                class="col-12"
              >
                <div class="d-flex flex-wrap border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <!-- class="text-lightgrey" -->
                    <strong>Offer Applied</strong>
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-between">
                      <strong class="d-block text-danger"
                        ><span>-{{ currFormat(offerPrice) }}</span
                        >&nbsp;{{ currencyData.curr_code }}</strong
                      >
                      <img
                        @click="onRemoveOffer()"
                        class="d-table position-relative"
                        src="@/assets/img/icons/delete.svg"
                        height="20"
                        width="20"
                      />
                    </div>
                  </div>
                  <div class="col-12 pt-1 px-0">
                    <!-- <Tooltip
                      :title="`Offer Details here`"
                      :src="`question2.svg`"
                    /> -->
                    <strong class="fs-10"
                      >({{
                        offerApplied.offer_title ||
                          offerApplied.offer_code ||
                          offerApplied.voucher_title ||
                          offerApplied.voucher_code
                      }})</strong
                    >
                  </div>
                  <div class="col-4 pr-0">
                    <div class="d-flex w-100 justify-content-between"></div>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  RemainingCashRefundOfferAmount &&
                    parseInt(RemainingCashRefundOfferAmount) > 0
                "
                class="col-12"
              >
                <div class="d-flex flex-wrap border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <!-- class="text-lightgrey" -->
                    <strong>Cash Refund</strong>
                  </div>
                  <div class="col-7 px-0">
                    <div class="d-flex justify-content-between">
                      <strong class="d-block text-danger"
                        ><span>{{
                          currFormat(RemainingCashRefundOfferAmount)
                        }}</span
                        >&nbsp;{{ currencyData.curr_code }}</strong
                      >
                    </div>
                  </div>

                  <div class="col-4 pr-0">
                    <div class="d-flex w-100 justify-content-between"></div>
                  </div>
                </div>
              </div>

              <div v-if="isLoyaltyApplied" class="col-12">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">Loyalty Applied</span>
                    <strong>{{ LoyaltyProgram }}</strong
                    >&nbsp;
                    <div class="d-flex">
                      <img
                        class="d-table position-relative"
                        src="@/assets/img/icons/question2.svg"
                        v-b-tooltip.hover
                        title="Offer Details here"
                        height="18"
                        width="18"
                      />
                      <img
                        @click="resetLoyaltyData()"
                        class="d-table position-relative"
                        src="@/assets/img/icons/delete.svg"
                        height="18"
                        width="18"
                      />
                    </div>
                  </div>
                  <div class="col-7 px-0">
                    <strong class="d-block">
                      <!-- {{ offerApplied.oc_discount_value }} {{currencyData.curr_code}} -->
                      {{ currFormat(getloyaltyAmount) }}&nbsp;{{
                        currencyData.curr_code
                      }}
                    </strong>
                    <div class="d-flex flex-wrap mt-2"></div>
                  </div>
                </div>
              </div>

              <div class="col-12" v-if="isCashCardTransaction">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">Cash Card</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ isCashCardDetail.cash_card_number }}</strong>
                  </div>
                </div>
                <div class="d-flex border-bottom-lightgrey py-1 text-danger">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">Cash Card Amount</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong
                      >-{{
                        isCashCardDetail && isCashCardDetail.cardAmount
                          ? parseFloat(isCashCardDetail.cardAmount).toFixed(2)
                          : "0.00"
                      }}&nbsp;{{ currencyData.curr_code }}</strong
                    >
                    <img
                      @click="onRemoveCashCard()"
                      class="d-table position-relative"
                      src="@/assets/img/icons/delete.svg"
                      height="20"
                      width="20"
                    />
                  </div>
                </div>
              </div>
              
              <div class="col-12" v-if="MeritCardAmount > 0 && GET_MERIT_GIFT_CARD_DETAILS.isApplied == 'Y'">
                <div class="d-flex border-bottom-lightgrey py-1">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">Merit Gift Card</span>
                  </div>
                  <div class="col-7 px-0">
                    <strong>{{ GET_MERIT_GIFT_CARD_DETAILS.card_number }}</strong>
                  </div>
                </div>
                <div class="d-flex border-bottom-lightgrey py-1 text-danger">
                  <div class="col-5 pl-0">
                    <span class="text-lightgrey">Gift Card Amount</span>
                  </div>
                  <div class="col-7 px-0 d-flex align-item-center justify-content-between pr-3">
                    <strong
                      >-{{
                        MeritCardAmount > 0 && GET_MERIT_GIFT_CARD_DETAILS.isApplied == 'Y'
                          ? parseFloat(MeritCardAmount).toFixed(2)
                          : "0.00"
                      }}&nbsp;{{ currencyData.curr_code }}</strong
                    >
                    <img
                      @click="onRemoveMeritGiftCard()"
                      class="d-table position-relative"
                      src="@/assets/img/icons/delete.svg"
                      height="20"
                      width="20"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- TOTAL DIV -->
            <div class="col-12 border-top py-2" v-if="checkCompleteRateCard">
              <div class="row">
                <div class="col-5">
                  <h6 class="mb-0 font-weight-bold fs-18">Total</h6>
                </div>
                <div class="col-7 px-0">
                  <h6
                    v-if="isLoyaltyApplied && !isSwap"
                    class="font-weight-bold mb-0 fs-18 text-truncate"
                  >
                    {{ currFormat(parseFloat(totalAmount) - parseFloat(getloyaltyAmount)) }}
                    {{ currencyData.curr_code }}
                  </h6>
                  <h6
                    v-else-if="isSwap"
                    class="font-weight-bold mb-0 fs-18 text-truncate"
                  >
                    {{
                      currFormat(parseFloat(totalAmount) -
                        parseFloat(getloyaltyAmount))
                    }}
                    {{ currencyData.curr_code }}
                  </h6>
                  <h6 v-else class="font-weight-bold mb-0 fs-18 text-truncate">
                    {{ parseFloat(totalAmount).toFixed(2) }} {{ currencyData.curr_code }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <PosRefund v-if="childComponents.PosRefund" :onClickHandler="onClickCall" />

    <FnbRefund v-if="childComponents.FnbRefund" :onClickHandler="onClickCall" />

    <Swap
      v-if="childComponents.Swap"
      :onClickHandler="onClickCall"
      :view="isSwap"
    />

    <CashCardPos
      fullscreen
      SectionType="topUp"
      :onClickHandler="onClickCall"
      :onClickAddMoney="onClickAddMoney"
      v-if="childComponents.cashCard"
    />

    <PosUserCollection
      v-if="childComponents.posUserCollection"
      :onClickHandler="onClickCall"
    />

    <PosUserTransaction
      v-if="childComponents.posUserTransaction"
      :onClickHandler="onClickCall"
    />
    <PosUserFnbTransaction
      v-if="childComponents.posUserFnbTransaction"
      :onClickHandler="onClickCall"
    />

    <UnpaidBooking
      v-if="childComponents.UnpaidBooking"
      :onClickHandler="onClickCall"
      :onClickSeat="onClickSeat"
      :enableClass="removeClass"
    />

    <PosSchedule
      v-if="childComponents.PosSchedule"
      :childComponents="childComponents"
      :onClickCloseHandler="onClickCall"
    />

    <PosOccupancyStatus
      v-if="childComponents.PosOccupancyStatus"
      :onClickCloseHandler="onClickCall"
    />

    <PosPickUpTicket
      v-if="childComponents.PosPickUpTicket"
      :onClickHandler="onClickCall"
    />

    <PosFinalTicket
      :onBackHandler="onBackHandler"
      :onClickCloseButton="onClickCloseButton"
      v-if="childComponents.PosFinalTicket"
      :onClickHandler="onClickCall"
    />

    <CashCardFinalPage
      :onClickHandler="onClickCall"
      v-if="childComponents.CashCardFinalPage"
      :onClickCloseButton="onClickCloseButton"
      :Currency="currencyData.curr_code"
    />

    <PosCustomerLoyaltyPoints
      :onBackHandler="onBackHandler"
      :onClickCloseButton="onClickCloseButton"
      v-if="childComponents.PosCustomerLoyaltyPoints"
      :onClickHandler="onClickCall"
    />

    <PosPackageFinalTicket
      v-if="childComponents.PosPackageFinalTicket"
      :onBackHandler="onBackHandler"
      :onClickCloseButton="onClickCloseButton"
      :onClickHandler="onClickCall"
      :itemsList="SelectedFnbItemList"
      :taxesTotal="TotalAdditionalTaxes"
      :taxes="AdditionalTaxList"
      :subTotal="selectedFnBItemsTotalPrice"
      :currency="currencyData.curr_code"
    />

    <PosFooter
      v-if="!fullscreen"
      ref="posFooterComponent"
      :onClickCloseButton="onClickCloseButton"
      :section="section"
      :onClickSeat="onClickSeat"
      :enableClass="removeClass"
      :onBackHandler="onBackHandler"
      :onClickHandler="onClickCall"
      :onClickYes="WithoutOffer"
      :onUnpaidBookingCancel="onUnpaidBookingCancel"
    />
    <!-- Verify Voucher Modal -->
    <b-modal
      id="verifyVoucher"
      ref="verifyVoucher"
      title="Verify Voucher"
      hide-footer
      show
      @hide="clearVoucherCode"
      @shown="handleOpenVoucherCodeModal"
    >
      <div>
        <div class="row mb-3 mt-2">
          <!-- <h6 class="px-3">Voucher Code</h6> -->
          <!-- :value="getVoucherCode" -->
          <div class="col-10 mb-4 d-flex input-material mx-auto">
            <input
              placeholder="Voucher Code"
              type="text"
              v-model="voucherCodeValue"
              v-on:keyup.enter="
                applyOffersHandler({
                  event: $event,
                  offer: selectedVoucherForVerifcation,
                  offerFor: 'vouchers',
                  booking_source_id: 1,
                  checkSpecificTitle: 'Y',
                })
              "
              @input="
                onEnterVoucherCode({
                  event: $event,
                  name: 'enterVoucherCode'
                })
              "
              name="voucherCode"
              id="voucherCode"
              class="form-control"
            />
            <label>{{ "Enter Voucher Code" }}</label>
            <VkeyboardFloat
              :ID="'voucherCode'"
              :onClickFun="
                () => {
                  Object.keys(keyboardsVisible).map(x => {
                    if (x == 'showVerifyVoucher') {
                      keyboardsVisible[x] = !keyboardsVisible[x];
                    } else {
                      keyboardsVisible[x] = false;
                    }
                  });
                }
              "
            />
            <Vkeyboard
              :inputName="'voucherCode'"
              :showOrHide="keyboardsVisible.showVerifyVoucher"
              :initialValue="voucherCodeValue"
              @onChangeEvent="() => {}"
              @onKeyEnter="
                applyOffersHandler({
                  event: $event,
                  offer: selectedVoucherForVerifcation,
                  offerFor: 'vouchers',
                  booking_source_id: 1,
                  checkSpecificTitle: 'Y',
                })
              "
              @changeKeyboardInput="
                event => {
                  voucherCodeValue = event;
                  onEnterVoucherCode({
                    event: {
                      target: {
                        value: event
                      }
                    },
                    name: 'enterVoucherCode'
                  });
                }
              "
              @onClickClose="
                () => {
                  keyboardsVisible.showVerifyVoucher = false;
                }
              "
            />
          </div>
          <!-- <h6 class="px-3">Comment</h6> -->
          <!-- <div class="col-10 mb-4 d-flex input-material mx-auto">
            <input
              placeholder="Comment"
              type="text"
              :value="getTransactionComment"
              @input="onInputComment($event)"
              name="voucherComment"
              id="voucherComment"
              class="form-control"
            />
            <label>{{ "Enter Comment" }}</label>
          </div> -->
          <div class="col-12 py-2 text-center">
            <button
              @click="
                applyOffersHandler({
                  event: $event,
                  offer: selectedVoucherForVerifcation,
                  offerFor: 'vouchers',
                  booking_source_id: 1,
                   checkSpecificTitle: 'Y',
                })
              "
              class="btn-blue ml-5"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-backdrop
      ref="tt_modal_open_voucher"
      id="tt_modal_open_voucher"
      class=""
      size="lg"
    >
      <div class="d-flex flex-column">
        <div class="d-flex border-bottom border-dark">
          <div class="col-6">
            <h5 class="font-weight-bold mt-2">
              {{ $t("complementory_modal_titel") }}
            </h5>
          </div>
          <div class="col-6 text-right">
            <button
              class="btn-modal-close ml-auto"
              @click="$bvModal.hide('tt_modal_open_voucher')"
            >
              &times;
            </button>
          </div>
        </div>

        <div
          class="d-flex align-items-center border-bottom flex-wrap"
          v-for="(item, index) in seatTypeOpenVoucher"
          :key="index"
        >
          <div class="seat-type gold" :style="'color:red'">
            <div class="st-name">{{ item.sst_seat_type }}</div>
            <div>{{ item.selected }}/{{ item.totalTicketType }}</div>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <div class="category">
              <div class="category-name">
                {{ item.tt_name }}
              </div>
              <div class="category-price">
                {{ currency }} {{ item.SinglePrice }}
              </div>
              <div class="category-seats">
                <div
                  class="mod-btn"
                  :id="`decrement${index + 1}`"
                  @click="
                    changeCountHandlerOpenVoucher({
                      item: item,
                      index: index,
                      type: 'decrement'
                    })
                  "
                  :class="item.selected == 0 ? 'disabled' : ''"
                >
                  -
                </div>
                <div>{{ item.selected }}</div>
                <!--item.selected--->
                <div
                  class="mod-btn"
                  :id="`increment${index + 1}`"
                  @click="
                    changeCountHandlerOpenVoucher({
                      item: item,
                      index: index,
                      type: 'increment'
                    })
                  "
                  :class="
                    item.selected == item.totalTicketType ? 'disabled' : ''
                  "
                >
                  +
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 py-2 text-center">
          <button class="btn-blue ml-5" @click="applyTicketTypeOpenVoucher">
            Apply
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="refund_cash_popup"
      ref="refund_cash_popup"
      title="Cash Refund"
      hide-footer
      show
      @hide="handleSubmit"
      @shown="handleRemainingPriceModal"
    >
      <div>
        <div class="row mb-3 mt-2">
          <h6 class="px-3">
            Ticket Amount : {{ this.$store.getters.TOTAL_AMOUNT.toFixed(2) }}
            {{ currencyData["curr_code"] }}
          </h6>
          <br />
          <h6 class="px-3">
            Voucher Amount :
            {{
              parseFloat(
                parseFloat(offerPrice) +
                  parseFloat(RemainingCashRefundOfferAmount)
              ).toFixed(2)
            }}
            {{ currencyData["curr_code"] }}
          </h6>
          <br />
          <h6 class="px-3">
            Refund Cash Amount: {{ RemainingCashRefundOfferAmount }}
            {{ currencyData["curr_code"] }}
          </h6>
          <div class="col-12 py-2 text-center">
            <input
              v-on:keyup.enter="handleSubmit()"
              type="text"
              autofocus
              style="width: 0; height: 0; border: #fff"
              v-model="remainingOfferPrice"
              ref="remainingOfferPrice"
            />
            <button class="btn-blue" type="submit" @click="handleSubmit">
              Confirm
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="total_discount_popup"
      ref="total_discount_popup"
      title="Total Discount"
      hide-footer
      show
      @hide="closeTotalDiscount"
      @shown="handleOpenModal"
    >
      <div>
        <div class="row mb-3 mt-2">
          <!-- <h6 class="px-3">Voucher Code</h6> -->
          <div class="col-10 mb-4 d-flex input-material mx-auto">
            <input
              placeholder="Enter Amount"
              type="number"
              autofocus
              v-on:keyup.enter="checkOpenVoucherAmount"
              v-model="totalofferDiscountov"
              name="totalofferDiscountov"
              id="totalofferDiscountov"
              ref="totalofferDiscountov"
              class="form-control"
            />
            <label>{{ "Enter Amount" }}</label>
          </div>

          <div class="pos-mobile-number">
            <div>
              <div class="row">
                <div class="col-12 mx-auto">
                  <div class="row">
                    <div
                      class="col-4 mb-2"
                      v-for="(value, index) in keypadValues"
                      :key="index"
                    >
                      <button
                        v-if="index == keypadValues.length - 1"
                        class="number"
                        v-on:click="sliceNumber()"
                      >
                        {{ value.name }}
                      </button>
                      <button
                        v-else-if="value.name != ''"
                        v-on:click="onClicknumber(index)"
                        class="number"
                      >
                        {{ value.name }}
                      </button>
                      <button
                        v-else
                        @click.prevent.stop="clearInput"
                        class="number"
                      >
                        C
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 py-2 text-center">
            <button class="btn-blue" @click="checkOpenVoucherAmount">
              Apply
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="total_discount_popup_tt"
      ref="total_discount_popup_tt"
      title="Total Discount"
      hide-footer
      show
    >
      <div>
        <div class="row mb-3 mt-2">
          <!-- <h6 class="px-3">Voucher Code</h6> -->
          <div
            class="
              d-flex
              align-items-center
              w-75
              mx-auto
              border-bottom
              flex-wrap
            "
            v-for="(item, index) in seatTypeOpenVoucher"
            :key="index"
          >
            <div class="mb-3">
              <div class="text-muted">{{ item.sst_seat_type }}</div>
            </div>
            <div class="mb-4 d-flex input-material mx-auto">
              <input
                :value="item.VoucherAmount"
                @input="
                  onEnterVoucherAmount({
                    event: $event,
                    index: index
                  })
                "
                placeholder="Enter Amount"
                type="number"
                name="totalofferDiscountovtt"
                id="totalofferDiscountovtt"
                class="form-control"
              />
              <label>{{ "Enter Amount" }}</label>
            </div>
          </div>

          <div class="col-12 py-2 text-center">
            <button class="btn-blue ml-5" @click="checkOpenVoucherAmount_tt">
              Apply
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="applicable-offer-modal"
      id="pos-applicable-offers"
      size="lg"
      hide-header
      hide-footer
    >
      <div>
        <h4 class="text-center py-3">All Applicable Offers:</h4>
        <button
          class="btn-modal-close pos-modal-close"
          @click="closeApplicableOffersModal"
        >
          &times;
        </button>
        <b-tabs content-class="mt-3">
          <b-tab
            title="Offers &amp; Promotions"
            v-if="getOffersCollection.length > 0"
          >
            <div class="applicable-offer-wrapper">
              <ul
                v-if="getOffersCollection && getOffersCollection.length > 0"
                class="pos-applicable-offers-list"
              >
                <li
                  class
                  v-for="(OffersItem, OffersIndex) in getOffersCollection"
                  v-if="checkOfferType(OffersItem)"
                  :key="OffersIndex"
                >
                  <div
                    name="applicableOffers"
                    v-model="ApplicableOfferSelected"
                    class="j-radio"
                  >
                    <div v-if="String(OffersItem.offer_type_id) === '1'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Buy {{ OffersItem.oc_buy_no_of_ticket }} Tickets Get
                      {{ OffersItem.oc_get_free_ticket }} Tickets Free
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '2'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Buy {{ OffersItem.oc_buy_no_of_ticket }}
                      {{
                        OffersItem.offer_redeem_at_concession == "Y"
                          ? "Tickets/Items"
                          : "Tickets"
                      }}
                      &amp; Get Discount of {{ OffersItem.oc_discount_value }}
                      {{
                        OffersItem.oc_discount_value_is_percentage === "Y"
                          ? "%"
                          : currencyData["curr_code"]
                      }}
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '3'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Combo Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '4'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      {{ OffersItem.buc_category_name }} Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '5'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Bank Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '6'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Promo code Offers
                    </div>
                    <div v-else-if="String(OffersItem.offer_type_id) === '7'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      <br />
                      Buy {{ OffersItem.oc_buy_no_of_ticket }}
                      {{
                        OffersItem.offer_redeem_at_concession == "Y"
                          ? "Tickets/Items"
                          : "Tickets"
                      }}
                      &amp; Get Flat {{ OffersItem.oc_discount_value }}
                      {{
                        OffersItem.oc_discount_value_is_percentage === "Y"
                          ? "%"
                          : currencyData["curr_code"]
                      }}
                      OFF.&nbsp;Only for Loyality Members
                    </div>

                    <div v-else-if="OffersItem.offer_type_id == '8'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Get Flat {{ OffersItem.oc_discount_value }}
                      {{
                        OffersItem.oc_discount_value_is_percentage === "Y"
                          ? "%"
                          : currencyData["curr_code"]
                      }}
                      OFF
                    </div>

                    <div v-else-if="OffersItem.offer_type_id == '9'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                       {{getOfferDescription(OffersItem)}}
                    </div>

                    <div v-else-if="OffersItem.offer_type_id == '10'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      {{getOfferDescription(OffersItem)}}
                    </div>

                    <div v-else>
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                      Not Available
                    </div>
                  </div>

                  <!-- @click="onApplyOffer(OffersItem)" -->
                  <button
                    @click="
                      onClickApplyOffer({
                        event: $event,
                        offer: OffersItem,
                        offerFor: 'offersAndPromotions',
                        booking_source_id: 1,
                        checkSpecificTitle: 'Y'
                      })
                    "
                    class="btn-blue"
                  >
                    Apply
                  </button>
                  <button
                    v-b-toggle="'offer-details-' + OffersItem.os_id"
                    class="btn-transparent"
                  >
                    <small>Show Details</small>
                  </button>

                  <b-collapse :id="'offer-details-' + OffersItem.os_id">
                    <ul
                      v-if="String(OffersItem.offer_type_id) === '1'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Minimun Ticket Price:
                        {{ OffersItem.oc_min_ticket_price }}
                      </li>
                      <li class="py-1">
                        Maximum Free Tickets Per Transactions:
                        {{ OffersItem.oc_max_no_of_ticket_per_transaction }}
                      </li>
                    </ul>
                    <ul
                      v-else-if="
                        String(OffersItem.offer_type_id) === '2' ||
                          String(OffersItem.offer_type_id) === '8'
                      "
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Maximum discount per transaction:
                        {{ OffersItem.oc_max_discount_amount }}
                      </li>
                      <!-- <li class="py-1">Maximum Free Tickets Per Transactions: {{ OffersItem.oc_max_no_of_ticket_per_transaction }}</li> -->
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '3'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Offer Combine With:
                        {{
                          OffersItem.oc_is_combo_with_fnb === "Y"
                            ? "F&B"
                            : "BoxOffice"
                        }}
                      </li>
                      <li
                        class="py-1"
                        v-if="OffersItem.oc_is_combo_with_fnb === 'Y'"
                      >
                        Buy {{ OffersItem.oc_buy_item_count }}
                        {{ OffersItem.buy_item_name }} F&amp;B Item &amp; Get
                        {{ OffersItem.oc_get_item_count }}
                        {{ OffersItem.get_item_name }} F&amp;B Item
                        <span v-if="OffersItem.oc_is_combo_free === 'Y'">{{
                          "Is Free"
                        }}</span>
                        <span v-if="OffersItem.oc_is_combo_free === 'N'"
                          >{{ OffersItem.oc_discount_value }}
                          {{
                            OffersItem.oc_discount_value_is_percentage === "Y"
                              ? "% OFF"
                              : `${currencyData["curr_code"]} OFF`
                          }}</span
                        >
                      </li>
                      <li
                        class="py-1"
                        v-if="OffersItem.oc_is_combo_with_fnb === 'N'"
                      >
                        Buy Tickets {{ OffersItem.oc_buy_no_of_ticket }} &amp;
                        Get F&amp;B Item {{ OffersItem.get_item_name }}
                        <span v-if="OffersItem.oc_is_combo_free === 'Y'">{{
                          "Is Free"
                        }}</span>
                        <span v-if="OffersItem.oc_is_combo_free === 'N'"
                          >{{ OffersItem.oc_discount_value }}
                          {{
                            OffersItem.oc_discount_value_is_percentage === "Y"
                              ? "% OFF"
                              : `${currencyData["curr_code"]} OFF`
                          }}</span
                        >
                      </li>
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '4'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Minimun Ticket Price:
                        {{ OffersItem.cco_min_ticket_amount }}
                      </li>
                      <li class="py-1">
                        Maximum discount per transaction:
                        {{ OffersItem.cco_max_discount_amount }}
                      </li>
                      <li class="py-1">
                        Offer Price: {{ OffersItem.cco_offer_value }}
                        {{
                          OffersItem.cco_offer_value_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.cco_instruction"></span>
                      </li>
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '5'"
                      class="small pt-3"
                    >
                      <div class="mb-3">
                        <div class="d-flex align-items-center w-75">
                          <div class="input-material">
                            <input
                              @input="updateCardNumber"
                              name="card_number"
                              id="card_number"
                              placeholder="."
                              v-validate="'numeric|min:12|max:12'"
                              type="text"
                            />
                            <label>Card Number</label>
                          </div>
                        </div>
                      </div>
                      <li class="py-1">
                        Bank Name: {{ OffersItem.bank_name }}
                      </li>
                      <li class="py-1">
                        Bank Card: {{ OffersItem.card_type }}
                      </li>
                      <li class="py-1" v-if="OffersItem.bo_weekly_redemption">
                        {{ "Weekly" }} Redemption:
                        {{ OffersItem.bo_weekly_redemption }}
                      </li>
                      <li class="py-1" v-if="OffersItem.bo_monthly_redemption">
                        {{ "Monthly" }} Redemption:
                        {{ OffersItem.bo_monthly_redemption }}
                      </li>
                      <li class="py-1" v-if="OffersItem.bo_yearly_redemption">
                        {{ "Yearly" }} Redemption:
                        {{ OffersItem.bo_yearly_redemption }}
                      </li>
                      <li class="py-1">
                        Offer Price: {{ OffersItem.bo_offer_value }}
                        {{
                          OffersItem.bo_offer_value_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.bo_instruction"></span>
                      </li>
                    </ul>
                    <ul
                      v-else-if="String(OffersItem.offer_type_id) === '6'"
                      class="small pt-3"
                    >
                      <li class="py-1">
                        Promo Code: {{ OffersItem.promo_code }} applicable for
                        {{
                          OffersItem.pcs_no_of_transactions
                            ? OffersItem.pcs_no_of_transactions
                            : "N/A"
                        }}
                        Transactions
                      </li>
                      <input
                        placeholder="."
                        type="text"
                        :value="promoCode"
                        @input="
                          onEnterPromoCodes({
                            event: $event,
                            name: 'enterPromoCode'
                          })
                        "
                        name="promocode"
                        id="promocode"
                      />
                      <!-- v-model="promocode" -->
                      <li class="py-1">
                        Categories: {{ OffersItem.booking_user_category_id }}
                      </li>
                      <li class="py-1">
                        Minimun Ticket Price:
                        {{ OffersItem.pcs_min_ticket_amount }}
                      </li>
                      <li class="py-1">
                        Maximum discount per transaction:
                        {{ OffersItem.pcs_max_discount_amount }}
                      </li>
                      <li class="py-1">
                        Offer Price: {{ OffersItem.pcs_offer_value }}
                        {{
                          OffersItem.pcs_offer_value_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li class="py-1">
                        Special Instruction:
                        <br />
                        <span v-html="OffersItem.pcs_instruction"></span>
                      </li>
                    </ul>
                    <ul
                    v-else-if="[9,10].includes(OffersItem.offer_type_id)"
                    class="small pt-3"
                  >
                    <li class="py-1">
                      {{getOfferDescription(OffersItem, true)}}
                    </li>
                    <li class="py-1" v-if="OffersItem.pcs_instruction">
                      Special Instruction:
                      <br />
                      <span v-html="OffersItem.pcs_instruction"></span>
                    </li>
                  </ul>
                    <ul v-else class="small pt-3">
                      <li class="py-1"></li>
                    </ul>
                  </b-collapse>
                </li>
              </ul>
              <ul v-else>
                <li>
                  <div>No Offers Found</div>
                </li>
              </ul>
            </div>
          </b-tab>

          <b-tab title="Vouchers" lazy>
            <!-- <div class="applicable-offer-wrapper">Sorry! There is no records found</div> -->
            <div class="applicable-offer-wrapper">
              <ul
                v-if="
                  getOffersVoucherCollection &&
                    getOffersVoucherCollection.length > 0
                "
                class="pos-applicable-offers-list"
              >
                <li
                  class
                  v-for="(OffersVoucherItem,
                  OffersVoucherIndex) in getOffersVoucherCollection"
                  :key="OffersVoucherIndex"
                  v-if="
                    OffersVoucherItem.is_open_voucher == 'N' &&
                      OffersVoucherItem.vs_redeem_at_boxoffice == 'Y'
                  "
                >
                  <div
                    name="applicableOffers"
                    v-model="ApplicableOfferSelected"
                    class="j-radio"
                  >
                    <div>
                      <strong
                        >{{
                          OffersVoucherItem.is_code_required == "N"
                            ? OffersVoucherItem.voucher_code + " -"
                            : ""
                        }}
                        {{ OffersVoucherItem.voucher_title }}</strong
                      >
                      <span
                        v-if="OffersVoucherItem.is_complemetory_ticket == 'Y'"
                        class="fs-12"
                      >
                        : ({{ $t("complemetory") }})<span
                          class="status-dot active"
                        ></span>
                      </span>
                      <span
                        v-else-if="OffersVoucherItem.is_open_voucher == 'Y'"
                      >
                        <span class="status-dot active"></span>
                      </span>
                      <span v-else>
                        : {{ OffersVoucherItem.voucher_amount
                        }}{{
                          OffersVoucherItem.voucher_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                        Off
                      </span>
                      <!-- VOUCHER CODE: {{ OffersVoucherItem.voucher_code }} -->
                    </div>
                  </div>

                  <!-- @click="onApplyOffer(OffersItem)" -->
                  <button
                    class="btn-blue"
                    @click="checkVoucherDetails(OffersVoucherItem)"
                  >
                    Apply
                  </button>
                  <button
                    v-b-toggle="
                      'offer-voucher-details-' + OffersVoucherItem.voucher_id
                    "
                    class="btn-transparent"
                  >
                    <small>Show Details</small>
                  </button>

                  <b-collapse
                    :id="
                      'offer-voucher-details-' + OffersVoucherItem.voucher_id
                    "
                  >
                    <ul
                      v-if="OffersVoucherItem.is_open_voucher == 'Y'"
                      class="fs-12"
                    >
                      <li class="py-1" v-if="OffersVoucherItem.tt_name">
                        Ticket Type: {{ OffersVoucherItem.tt_name }}
                      </li>
                      <li class="py-1" v-if="OffersVoucherItem.voucher_terms">
                        Terms &amp; Conditions:
                        <br />
                        <span v-html="OffersVoucherItem.voucher_terms"></span>
                      </li>
                    </ul>
                    <ul class="small pt-3" v-else>
                      <!--   v-if="OffersVoucherItem.hasMultiple == 'Y'" -->
                      <li
                        v-if="OffersVoucherItem.is_voucher_type_value == 'Y'"
                        class="py-1"
                      >
                        Voucher value: {{ OffersVoucherItem.voucher_amount
                        }}{{
                          OffersVoucherItem.voucher_is_percentage === "Y"
                            ? "%"
                            : currencyData["curr_code"]
                        }}
                      </li>
                      <li v-else class="py-1">
                        Voucher Type: Buy
                        {{ OffersVoucherItem.voucher_buy_no_of_ticket }} get
                        {{ OffersVoucherItem.voucher_get_free_ticket }} free
                        ticket(s)
                      </li>
                      <li class="py-1">
                        Min Bill/ticket amount for redemption:
                        {{ OffersVoucherItem.voucher_min_redemption_amount }}
                      </li>
                      <li class="py-1">
                        Max Bill/ticket amount for redemption:
                        {{ OffersVoucherItem.voucher_max_redemption_amount }}
                      </li>
                      <li class="py-1" v-if="OffersVoucherItem.voucher_terms">
                        Terms &amp; Conditions:
                        <br />
                        <span v-html="OffersVoucherItem.voucher_terms"></span>
                      </li>
                      <li v-if="OffersVoucherItem.vp_partner_name" class="py-1">
                        Partner Name:
                        <br />
                        <span v-html="OffersVoucherItem.vp_partner_name"></span>
                      </li>
                      <!--  -->
                    </ul>

                    <!-- <ul v-else class="small pt-3">
                      <li class="py-1"></li>
                    </ul>-->
                  </b-collapse>
                </li>
              </ul>
              <ul v-else>
                <li>
                  <div>No Vouchers Found</div>
                </li>
              </ul>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>

    <b-modal
      ref="applicableOfferNotValid"
      id="pos-applicable-offers-not-valid"
      size="lg"
      hide-header
      hide-footer
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
    >
      <div>
        <h4 class="text-center py-3">
          Your card is not valid for this offer,
          <br />Do you still want to continue your transaction ?
        </h4>
        <div class="text-center">
          <button @click="onClick('cancel')" class="btn-outline-blue">
            Cancel
          </button>
          <button @click="onClick('retry')" class="btn-blue">Retry</button>
          <button @click="onClick('yes')" class="btn-blue">Yes</button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="topUpCashCardPopup"
      ref="topUpCashCardPopup"
      title="Add Cash SuccessFull!"
      hide-footer
      @hide="TOPUP_COMPLETE"
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-14 mb-4 text-muted">
          <span>
            {{
              CustTopUpData && CustTopUpData.message
                ? CustTopUpData.message
                : "Add Cash SuccessFull."
            }}
          </span>
        </p>
        <p class="fs-14 mb-4 text-muted">
          <span>
            {{ $t("balance_amount") }}:&nbsp; {{ currencyData.curr_code }}&nbsp;
            {{
              CustTopUpData && CustTopUpData.balance_amount
                ? currFormat(CustTopUpData.balance_amount)
                : "-"
            }}
          </span>
        </p>

        <button
          class="btn btn-primary btn-danger-lg px-4 fs-14"
          @click.prevent.stop="TOPUP_COMPLETE"
        >
          Ok
        </button>
      </div>
      <div id="v-idle" style="display: none">
        <v-idle
          @idle="TOPUP_COMPLETE"
          :events="['mousemove', 'keypress', 'ontouchstart', 'onclick']"
          :loop="true"
          :duration="60 * 60"
        />
      </div>
    </b-modal>
    <b-modal
      id="extendSeatRelease"
      title="Seat Release"
      hide-footer
      hide-header
      no-close-on-backdrop
      @shown="onShowSeatReleasePopUp"
      @hide="onHideSeatReleasePopUp"
    >
      <div class="text-center pb-1">
        <div class="svg-container">
          <svg
            width="40pt"
            height="40pt"
            version="1.1"
            viewBox="0 0 1200 1200"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="#ffd65b">
              <path
                d="m1110.4 938.2-426.89-693.25c-56.07-91.074-125.64-100.98-195.69-10.223-136.33 176.61-249.52 369.7-362.32 562.19-19.43 33.16-39.055 66.762-49.668 103.7-10.613 36.941-11.418 78.184 6.0195 112.43 27.441 53.895 90.504 63.438 150.75 62.586 867.37-10.098 822.88-6.6133 851.53-16.758 46.281-16.402 65.977-56.125 26.273-120.67zm-34.504 97.426c-24.562 8.6953 16.367 5.3359-843.58 15.348-44.805 0.73828-99.207-3.5469-120.01-40.004-19.488-34.129-0.64062-78.469 20.355-117.33h0.007813c167.91-310.92 303.09-483.67 368.43-586.42 21.879-34.418 44.508-69.992 70.031-96.879 7.2383-7.6328 15.734-12.711 26.199-11.637 22.645 2.3594 48.52 32.121 65.184 59.188l426.89 693.25c23.516 38.16 29.102 69.395-13.508 84.48z"
              />
              <path
                d="m780.21 125.03c-6.4219-2.2812-13.469 1.0742-15.75 7.4961l-30.621 86.078c-2.2812 6.4062 1.0664 13.453 7.4805 15.75 6.3789 2.25 13.449-1.0312 15.75-7.4961l30.621-86.078c2.2812-6.4062-1.0664-13.453-7.4805-15.75z"
              />
              <path
                d="m852.91 194.24c-20.004 26.922-43.891 50.582-70.996 70.328-5.5078 4.0117-6.7188 11.719-2.7031 17.227 4.0078 5.5312 11.742 6.6992 17.219 2.7148 29.121-21.223 54.781-46.633 76.277-75.562 4.0625-5.457 2.9219-13.18-2.543-17.242-5.4453-4.0781-13.168-2.9414-17.254 2.5352z"
              />
              <path
                d="m815.8 322.32c0.17578 6.6953 5.6602 12.008 12.32 12.008 9.3984-1.0586 32.441 0.10156 67.086-13.582 6.332-2.4883 9.4375-9.6484 6.9414-15.988-2.5117-6.3398-9.6797-9.457-15.996-6.9336-18.645 7.3516-38.27 11.332-58.336 11.848-6.8047 0.17578-12.184 5.8438-12.016 12.648z"
              />
              <path
                d="m609.96 389h-13.082c-17.531 0-31.742 14.211-31.742 31.742l0.003907 343.96c0 17.531 14.211 31.742 31.742 31.742 17.031 0 31.074-13.438 31.785-30.449 4.7812-114.63 8.1758-229.34 12.938-343.97 0.74609-18.02-13.609-33.023-31.645-33.023z"
              />
              <path
                d="m583.05 846.32-4.2969 1.4219c-19.625 7.7188-30.715 32.266-23.543 52.098 7.1758 19.828 31.406 31.598 51.426 24.973 20.02-6.625 32.453-30.523 26.383-50.719s-29.613-33.281-49.969-27.773z"
              />
            </g>
          </svg>
        </div>

        <p class="fs-16 mb-4">
          <span class="font-weight-bold">Alert!</span> <br />
          Your seats will be released in&nbsp;<span
            class="font-weight-bold text-danger"
            >{{ seatReleaseIn }}</span
          ><br />Do You Want to Extend Time ?
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('extendSeatRelease')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-blue px-4 fs-14"
          @click.prevent.stop="handleExtendSeatRelease"
        >
          Continue
        </button>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      title="Card Transaction Details"
      ref="manualCardDetailsNeoleap"
      id="manualCardDetailsNeoleap"
    >
      <div class="row settings-box mb-4">
        <div class="col-12 py-2">
          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center fs-11">
              Terminal ID:
            </div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.CardAcceptorTerminalId"
                    type="text"
                    id="CardAcceptorTerminalId"
                    name="CardAcceptorTerminalId"
                    @click="onClickInputHandler('tidKeyboard')"
                  />
                </div>
                <VkeyboardFloat
                  :ID="'CardAcceptorTerminalId'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'tidKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'CardAcceptorTerminalId'"
                  :showOrHide="keyboardsVisible.tidKeyboard"
                  :initialValue="
                    neoleapCardDetailsManual.CardAcceptorTerminalId
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.CardAcceptorTerminalId = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.tidKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center fs-11">
              Transaction RRN:
            </div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.RetrievalReferenceNumber"
                    type="text"
                    id="RetrievalReferenceNumber"
                    name="RetrievalReferenceNumber"
                    @click="onClickInputHandler('RRNKeyboard')"
                  />
                </div>
                <VkeyboardFloat
                  :ID="'RetrievalReferenceNumber'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'RRNKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'RetrievalReferenceNumber'"
                  :showOrHide="keyboardsVisible.RRNKeyboard"
                  :initialValue="
                    neoleapCardDetailsManual.RetrievalReferenceNumber
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.RetrievalReferenceNumber = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.RRNKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2" v-if="false">
            <div class="col-4 d-flex align-items-center fs-11">Card No:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    @input="onInputCardNumber($event)"
                    placeholder="."
                    v-model="cardNumber_unMasked"
                    type="text"
                    id="PrimaryAccountNumber"
                    name="PrimaryAccountNumber"
                    @click="onClickInputHandler('cardNumberKeyboard')"
                  />
                  <span class="text-muted fs-10">{{
                    neoleapCardDetailsManual.PrimaryAccountNumber
                  }}</span>
                </div>
                <VkeyboardFloat
                  :ID="'PrimaryAccountNumber'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'cardNumberKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'PrimaryAccountNumber'"
                  :showOrHide="keyboardsVisible.cardNumberKeyboard"
                  :initialValue="
                    neoleapCardDetailsManual.PrimaryAccountNumber
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.PrimaryAccountNumber = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.cardNumberKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center fs-11">
              Approval Code:
            </div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.AID"
                    type="text"
                    id="AID"
                    name="AID"
                    @click="onClickInputHandler('AIDKeyboard')"
                  />
                </div>
                <VkeyboardFloat
                  :ID="'AID'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'AIDKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'AID'"
                  :showOrHide="keyboardsVisible.AIDKeyboard"
                  :initialValue="
                    neoleapCardDetailsManual.AID
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.AID = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.AIDKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center fs-11">
              Card Scheme:
            </div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.CardScheme"
                    type="text"
                    id="CardScheme"
                    name="CardScheme"
                    @click="onClickInputHandler('CardSchemeKeyboard')"
                  />
                </div>
                <VkeyboardFloat
                  :ID="'CardScheme'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'CardSchemeKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'AID'"
                  :showOrHide="keyboardsVisible.CardSchemeKeyboard"
                  :initialValue="
                    neoleapCardDetailsManual.CardScheme
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.CardScheme = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.CardSchemeKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center fs-11">Card Name:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.CardNameEnglish"
                    type="text"
                    id="CardNameEnglish"
                    name="CardNameEnglish"
                    @click="onClickInputHandler('cardNameKeybaord')"
                  />
                </div>
                <VkeyboardFloat
                  :ID="'CardNameEnglish'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'cardNameKeybaord') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'CardNameEnglish'"
                  :showOrHide="keyboardsVisible.cardNameKeybaord"
                  :initialValue="
                    neoleapCardDetailsManual.CardNameEnglish
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.CardNameEnglish = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.cardNameKeybaord = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2" v-if="false">
            <div class="col-4 d-flex align-items-center fs-11">
              ECR Reference:
            </div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.ECRReferenceNumber"
                    type="text"
                    :disabled="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pt-3 text-center">
          <button
            v-on:click="neoleapManualCheckout()"
            class="btn-blue"
          >
            Checkout
          </button>
          <button
            @click.prevent.stop="$bvModal.hide('manualCardDetailsNeoleap')"
            class="btn-blue"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>

    <promoOffersPopup :type="'pos'" />

    <ManagerAuthLogin
      :moduleName="'posOfferAuth_pos_booking'"
      :onCheckAuth="onCheckOfferAuth"
      :refId="'posOfferAuth_pos_booking'"
    />
     <AddEmployeeDiscountDetails :moduleName="'pos_booking'" :refId="'addEmployeeDetails_pb'" :onCheckEmployeeDetails="onCheckEmployeeDetails"/>
  </div>
</template>

<script>
import Slick from "vue-slick";
import PosHeader from "@/components/Partials/posHeader.vue";
import PosFooter from "@/components/Partials/posFooter.vue";
import PosRefund from "@/components/Partials/posRefund.vue";
import FnbRefund from "@/components/Partials/FnbRefund.vue";
import Swap from "@/components/Partials/Swap.vue";
import UnpaidBooking from "@/components/Partials/UnpaidBooking.vue";
import PosOccupancyStatus from "@/components//Pages/PosBookingContainer//posOccupancyStatus.vue";
import PosUserCollection from "@/components//Pages/PosBookingContainer/posUserCollection.vue";
import PosUserTransaction from "@/components//Pages/PosBookingContainer/posUserTransaction.vue";
import PosUserFnbTransaction from "@/components//Pages/PosBookingContainer/posUserFnbTransaction.vue";
import PosSchedule from "@/components/Pages/PosBookingContainer/posSchedule.vue";
import PosPickUpTicket from "@/components/Pages/PosBookingContainer/posPickUpTickets.vue";
import PosCustomerLoyaltyPoints from "@/components/Pages/PosBookingContainer/posCustomerLoyaltyPoints.vue";
import PosFinalTicket from "@/components/Pages/PosBookingContainer/posFinalTicket.vue";
import PosPackageFinalTicket from "@/components/Pages/PosBookingContainer/posPackageFinalTicket.vue";
import PosCalculator from "@/components/Partials/posCalculator.vue";
import PosDateSlider from "@/components/Partials/posDateSlider.vue";
import PosSeatLayout from "@/components/Pages/PosBookingContainer/posSeatLayout.vue";
import MasterService from "@/services/MasterService.js";
import { BASEURL } from "@/config/index.js";
import moment from "moment";
import _ from "lodash";
import UserService from "@/services/UserService";

import { EventBus, backendSocket } from "@/main";

import { mapState, mapGetters, mapActions } from "vuex";

import CashCardPos from "@/components/Partials/CashCardPos";
import MeritGiftCardSection from "@/components/Partials/MeritGiftCardSection";
import CashCardFinalPage from "@/components/Partials/CashCardFinalPage";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import promoOffersPopup from "@/components/Partials/PromoOffersPopup.vue";
import { generateRandomCode } from "@/helper/collection";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import AddEmployeeDiscountDetails from "@/components/Partials/AddEmployeeDiscountDetails";

export default {
  components: {
    Slick,
    PosHeader,
    PosFooter,
    PosRefund,
    PosSchedule,
    PosDateSlider,
    PosPickUpTicket,
    PosFinalTicket,
    PosOccupancyStatus,
    PosCalculator,
    PosSeatLayout,
    UnpaidBooking,
    PosPackageFinalTicket,
    PosCustomerLoyaltyPoints,
    FnbRefund,
    Swap,
    PosUserCollection,
    PosUserTransaction,
    PosUserFnbTransaction,
    CashCardPos,
    MeritGiftCardSection,
    CashCardFinalPage,
    VkeyboardFloat,
    Vkeyboard,
    promoOffersPopup,
    ManagerAuthLogin,
    AddEmployeeDiscountDetails
  },
  data() {
    return {
      giftCardPmIds: ['23'],
      skipNeoleapResponse: 'N',
      neoPayType: 1,
      neo_orderRef: "",
      neo_ws: null,
      test_response: "",
      neo_click_count: 0,
      neo_retry_count: 0,
      creditTimeOut: "",
      keyboardsVisible: {
        showVoucherCodeKeyboard: false,
        showCommentKeyboard: false,
        showVerifyVoucher: false,
        tidKeyboard: false,
        RRNKeyboard: false,
        cardNumberKeyboard: false,
        AIDKeyboard: false,
        CardSchemeKeyboard: false,
        cardNameKeybaord: false,
      },
      showAddonBreakup: false,
      showSeatExtendPopUp: false,
      showSeatReleaseMsg: null,
      seatReleasePopUp: null,
      hideSeatExtendPopUp: null,
      voucherCodeValue: "",
      _seatTypeOpenVoucher: [
        {
          sst_seat_type: "Regular",
          tt_name: "Adult",
          totalTicketType: 5,
          SinglePrice: 52.5,
          tt_id: 1,
          sst_id: 1,
          selectedRateCard: 5,
          totalOfferPrice: 262.5
        },
        {
          sst_seat_type: "Gold",
          tt_name: "Adult",
          totalTicketType: 5,
          SinglePrice: 52.5,
          tt_id: 1,
          sst_id: 1,
          selectedRateCard: 5,
          totalOfferPrice: 262.5
        }
      ],
      totalofferDiscountov: "",
      remainingOfferPrice: "",
      submitted: false,
      screen_lock_time: null,
      screen_time: null,
      reverse_screen: false,
      currentTime: "",
      URL_BASE: BASEURL,
      selectedFormat: "All Formats",
      removeClass: true,
      silderOne: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 5
      },
      childComponents: {
        PosRefund: false,
        FnbRefund: false,
        Swap: false,
        PosSchedule: false,
        PosOccupancyStatus: false,
        PosPickUpTicket: false,
        PosFinalTicket: false,
        PosCustomerLoyaltyPoints: false,
        PosPackageFinalTicket: false,
        UnpaidBooking: false,
        posUserCollection: false,
        posUserTransaction: false,
        posUserFnbTransaction: false,
        cashCard: false,
        CashCardFinalPage: false
      },
      section: {
        // login: false,
        movieDetail: true,
        seatLayout: false,
        checkout: false,
        cashCardTopup: false
      },
      sectionHistory: ["movieDetail"],
      cinema_config: {},
      paymentTypes: {
        cashPayments: true,
        creditNDebit: false,
        cashless: false,
        splitPayments: false,
        couponNPromotions: false,
        vouchers: false,
        loyaltyCard: false
      },
      selectedTabIndex: 0,
      selectedFilterName: "date",
      fullscreen: false,
      Formats: [],
      FormatMethod: {
        GET: "/admin/",
        tableName: "ms_movie_formats",
        urlKey: "movieformats"
      },
      currencyData: [],
      // visibleShowsDates: [],
      // visibleShowsScreens: [],
      // visibleShowsLanguage: [],
      screenList: [],
      // offerApplied: {},
      showTime_seatlayout_details: {},
      ApplicableOfferSelected: false,
      promocode: null,
      // voucherCode: null,
      BankCardNumber: null,
      WithoutOffer: false,
      selectedVoucherForVerifcation: null,
      searchValue: "",
      selectedMovieLanguageFilter: null,
      selectedMovieFormatFilter: null,
      selectedMovieGenreFilter: null,
      selected_ssid: null,
      turnOffMultiSeatSelection: "N",
      VoucherCodeDeounce: "",
      open_ticket_discount_price: "",
      timePassed: 0,
      timeLeft: 0,
      timerInterval: null,
      seatReleaseIn: `00:00`,
      timTimeObj: {
        timePassed: 0,
        timeLeft: 0,
        timerInterval: null,
        transactionTimeOut: `00:00`,
        timeInSec: 120
      },
      neoLeapTimeObj: {
        timePassed: 0,
        timeLeft: 0,
        timerInterval: null,
        transactionTimeOut: `00:00`,
        timeInSec: 60
      },
      disableCreditPayBtn: false,
      machineDisplay: {
        displayText: "",
        status: true,
        processing: false
      },
      neoleapSkipTimer: null,
      neoleapCardDetailsManual: {
        StatusCode: "00",
        MerchantNameEnglish: "",
        MerchantNameArabic: "",
        MerchantAddress1English: "",
        MerchantAddress2English: "",
        MerchantAddress1Arabic: "",
        MerchantAddress2Arabic: "",
        download_phone: "",
        TransactionDateTime: "",
        TransacitonRequestDateTime: "",
        TransactionResponseDateTime: "",
        BankId: "",
        CardAcceptorIdCode: "   ",
        CardAcceptorTerminalId: "",
        TerminalVersion: "",
        CardAcceptorBusinessCode: "",
        TransactionSTAN: "",
        RetrievalReferenceNumber: "",
        CardSchemeID: "",
        CardNameArabic: "",
        CardNameEnglish: "",
        CardScheme: "",
        PrimaryAccountNumber: "",
        CardExpiryDate: "",
        TransactionTypeArabic: "",
        TransactionTypeEnglish: "PURCHASE",
        TransactionAmount: "",
        TransactionResponseEnglish: "NO RESPONSE",
        TransactionResponseArabic: "",
        TransactionResultReasonEnglish: "NO RESPONSE",
        TransactionResultReasonArabic: "",
        ResponseCodeDescription: "",
        TransactionAuthCode: "",
        TerminalModel: "",
        POSEntryMode: "MANUAL",
        TransactionResponse: "000",
        AID: "",
        TVR: "",
        TSI: "",
        CVMResult: "",
        CryptResult: "",
        ApplicationCryptogram: "",
        KID: "",
        ECRReferenceNumber: "",
      },
      tempSelectedOffer: null,
      employeeDetailsAuth: false,
      keypadValues: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" }
      ]
    };
  },
  watch: {
    "selectedPaymentMode.pm_id": function(newValue) {
      if (newValue == 13 || newValue == 12) {
        // setTimeout(() => {
        //   this.$nextTick(() => this.$refs.voucherInput.focus());
        // }, 500);
      }
    },
    "section.checkout": function(newValue) {
      if(newValue) {
        this.machineDisplay.processing = false
        this.skipNeoleapResponse = 'N'
        this.resetNeoleapManualData();
        clearTimeout(this.neoleapSkipTimer);
        clearInterval(this.neoLeapTimeObj.timerInterval);
        this.neo_retry_count = 0;
        this.neo_click_count = 0;
        this.resetNeoLeapTimer();
        console.log('CHECKING HARDWARE ON CHECKOUT SECTION');
        this.checkHardwareId();
      }
    },
    //  "$store.getters.showGenBtn":function(newVal){
    //    console.log('in here show genbtn:>> ');
    //   if(newVal){
    //   this.removeClass = true
    //   }
    // },
    "$store.getters.booking_complete": function(newVal) {
      if (newVal) {
        console.log("newVal", newVal);
        console.log("clearing TIme outs");
        clearTimeout(this.seatReleasePopUp);
        clearTimeout(this.hideSeatExtendPopUp);
        clearTimeout(this.showSeatReleaseMsg);
      }
    },
    "section.movieDetail": function(newVal, oldVal) {
      if (newVal) {
        this.onSetOffersFlags({ name: "isPosOffersShow", value: false });
      } else {
        console.log('EMPTYING THE MOVIES LIST');
        this.$store.commit("SET_ALL_SHOWS", []);
      }
    },
    "$store.getters.isOfferValidStatus": function(newVal, oldVal) {
      if (newVal == false) {
        this.$refs.applicableOfferNotValid.show();
      }
    },
    "$store.getters.SELECTED_SEATS": function(newVal, oldVal) {
      // console.log(
      //   "Object.keys(this.getSelectedOffer).filter((x)=> this.getSelectedOffer[x] !== null && this.getSelectedOffer[x] !== undefined).length > 0 :",
      //   Object.keys(this.getSelectedOffer).filter(
      //     x =>
      //       this.getSelectedOffer[x] !== null &&
      //       this.getSelectedOffer[x] !== undefined
      //   ).length > 0
      // );
      if (newVal && newVal.length === 0) {
        this.onResetOffersAndPrice();
      } else if (
        Object.keys(this.getSelectedOffer).filter(
          x =>
            this.getSelectedOffer[x] !== null &&
            this.getSelectedOffer[x] !== undefined
        ).length > 0
      ) {
        this.applyOffersHandler({
          event: null,
          offer: this.getSelectedOffer,
          offerFor: this.getOfferFor
        });
      }
    }
  },
  beforeDestroy() {
    // EventBus.$off("TERMINAL_STATUS");
    // EventBus.$off("TRANSACTION_COMPLETED");
    // clearTimeout(this.creditTimeOut)
    if (this.neo_ws) {
      this.disConnectNeoLeap();
    }
    clearInterval(this.timTimeObj.timerInterval);
  },
  destroyed() {
    if (this.timTimeObj.timerInterval) {
      this.onTransactionTimeOut();
    }
    if (this.neoLeapTimeObj.timerInterval) {
      this.onNeoLeapTimeOut();
    }
  },
  async beforeMount() {
    if (window.localStorage.getItem("Locked")) {
      this.$router.push({ path: "pos-lock-screen" });
    }
    let accessLimitation = this.secureStore.get("BRUACS");
    console.log("accessLimitation", accessLimitation);
    // if(accessLimitation != 'SUPER' && accessLimitation != 'POSONLY') {
    //   if(accessLimitation == 'FNBONLY') {
    //     this.$router.push({ path: "pos-fnb" });
    //   } else {
    //     this.$router.push({ path: "pos-login" });
    //   }
    // }
    // await this.setPosFooterMenus();
    this.getGlobalOptions();
    this.set_dropdown_area_language();
    EventBus.$on("removeVoucherCode", data => {
      console.log("Voucher Code Removed", data);
      // this.print();
      this.VoucherCodeDeounce = "";
    });
    EventBus.$on("startSeatRealeaseTimePOS", data => {
      console.log("Emitted On startSeatRealeaseTime POS ONLY");
      this.showSeatExtendPopUp = true;
      if (this.POS_SEAT_EXTEND_TIMER && this.POS_SEAT_EXTEND_TIMER > 0) {
        this.seatReleasePopUp = setTimeout(() => {
          this.timeLeftTimer();
          if (this.showSeatExtendPopUp) {
            console.log("line 3448 TEST extendSeatRelease called");
            this.$bvModal.show("extendSeatRelease");
          }
        }, this.POS_SEAT_EXTEND_TIMER);
      }

      if (
        this.CINE_SEAT_RELEASE_TIME_IN_MINS &&
        this.CINE_SEAT_RELEASE_TIME_IN_MINS > 0
      ) {
        clearTimeout(this.showSeatReleaseMsg);
        this.showSeatReleaseMsg = setTimeout(() => {
          console.log("seatTimeout start 3516");
          this.seatTimeout();
        }, this.CINE_SEAT_RELEASE_TIME_IN_MINS * 60 * 1000);
      }
    });
    EventBus.$on("clearSeatTimerPopUp", data => {
      console.log("Cleared Time Out Emit On");
      this.showSeatExtendPopUp = false;
      clearTimeout(this.seatReleasePopUp);
      clearTimeout(this.hideSeatExtendPopUp);
      clearTimeout(this.showSeatReleaseMsg);
      this.onTimesUp();
      this.$bvModal.hide("extendSeatRelease");
    });
    // idleLogout();
  },
  updated() {},
  created() {},
  destroyed: function() {
    console.log("called on destroyed");
    this.showSeatExtendPopUp = false;
    clearTimeout(this.seatReleasePopUp);
    clearTimeout(this.hideSeatExtendPopUp);
    clearTimeout(this.showSeatReleaseMsg);
    this.$bvModal.hide("extendSeatRelease");
    this.onTimesUp();
    try {
      if (this.$socket) {
        this.$socket.emit("home_page");
      }
    } catch (err) {}
  },
  async mounted() {
    this.releaseAllUnreservedSeats();
    this.$store.dispatch("MAKE_DATA_EMPTY");
    this.currentTime = Math.round(new Date().getTime() / 1000); //Unix Timestamp in Seconds;
    this.$store.dispatch("GET_DATES");
    this.getFormatList();
    let obj = this.secureStore.get("USINFO").cinema_id;
    if (obj) {
      this.getCinemaSettings(obj);
    }
    this._GetGlobalOptions()
      .then(() => {
        this.getCurrencyCode();
      })
      .catch(error => {
        this.$toasted.show("Error while fetching global options " + error);
      });

    this.fetchMovieLanguages();
    this.fetchMovieGenre();
    this.fetchMovieFormats();

    EventBus.$on("TERMINAL_STATUS", data => {
      console.log("Terminal Status");
    });

    EventBus.$on("TRANSACTION_COMPLETED", data => {
      if (this.routeName == "/pos-booking") {
        this.creditPay(data);
      }
    });

    EventBus.$on("DISPLAY_CONTENT", data => {
      console.log("DISPLAY_CONTENT", data);
      this.machineDisplay.displayText = data ? data : "";
    });

    this.checkHardwareId();
  },
  computed: {
    routeName: function() {
      return this.$route.path;
    },
    giftCardsPaymentModes() {
      let payment_modes_array = [...this.$store.getters.paymentModes] || [];
      let giftCardPayementModes = payment_modes_array.filter((x) => this.giftCardPmIds.includes(String(x.pm_id))) || []
      return giftCardPayementModes
    },
    paymentModesFiltered() {
      let payment_modes_array = [...this.$store.getters.paymentModes] || [];
      let giftCardPayementModes = payment_modes_array.filter((x) => this.giftCardPmIds.includes(String(x.pm_id))) || []
      if(giftCardPayementModes && giftCardPayementModes.length > 0 && !payment_modes_array.some((p) => p.payment_mode_id == 'GiftCard')) {
        let pmObj = {
          pm_id: 'GiftCard',
          payment_mode_id: 'GiftCard',
          pm_payment_mode: 'Others'
        }
        payment_modes_array.push(pmObj);
      }
      let filterGiftCards = payment_modes_array.filter((y) => !this.giftCardPmIds.includes(String(y.pm_id)))
      return filterGiftCards
    },
    get_pos_lock_screen_time() {
      return parseInt(this.$store.getters.POS_LOCK_SCREEN_TIME);
    },
    SELECTED_VOUCHER() {
      return this.$store.getters.tempOfferData;
    },
    GET_MERIT_GIFT_CARD_DETAILS() {
      return this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
    },
    MeritCardAmount() {
      let amount = 0;
      let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
      if(gc_details) {
        amount = +parseFloat(gc_details['amount']).toFixed(2)
      }
      // return amount
      return 0;
    },
    cashCardCustomerName() {
      console.log(
        "this.getCustomerDetails",
        this.getCustomerDetails,
        this.selectedTopUpCashCard
      );
      if (
        this.selectedTopUpCashCard.cust_name &&
        !this.selectedTopUpCashCard.cust_name == "-"
      ) {
        return this.selectedTopUpCashCard.cust_name;
      } else if (
        this.selectedTopUpCashCard.is_guest_user == "Y" &&
        this.selectedTopUpCashCard.hasOwnProperty("guest_first_name")
      ) {
        let text = `${this.selectedTopUpCashCard.guest_first_name +
          (this.selectedTopUpCashCard.guest_last_name
            ? " " + this.selectedTopUpCashCard.guest_last_name
            : "")}`;
        return text;
      } else if (
        this.getCustomerDetails &&
        this.getCustomerDetails.first_name
      ) {
        let text = `${this.getCustomerDetails.first_name +
          (this.getCustomerDetails.last_name
            ? " " + this.getCustomerDetails.last_name
            : "")}`;
        return text;
      } else {
        console.log("No customer details", this.getCustomerDetails);
        return "-";
      }
    },
    CustTopUpData() {
      return this.$store.getters.gettopData;
    },
    isCashCardTransaction() {
      return this.$store.getters.isCashCardTransaction;
    },
    reservationId() {
      return this.$store.getters.reservationId;
    },
    POS_SEAT_EXTEND_TIMER() {
      return this.$store.getters.POS_SEAT_EXTEND_TIMER;
    },
    POS_SEAT_ALERT_TIME_IN_SEC() {
      return this.$store.getters.POS_SEAT_ALERT_TIME_IN_SEC;
    },
    CINE_SEAT_RELEASE_TIME_IN_MINS() {
      return this.$store.getters.CINE_SEAT_RELEASE_TIME_IN_MINS;
    },
    cashCardCustMobileNumber() {
      return this.$store.getters.customer_mobile_number
        ? this.$store.getters.customer_mobile_number
        : this.selectedTopUpCashCard.cust_mobile
        ? this.selectedTopUpCashCard.cust_mobile
        : this.selectedTopUpCashCard.guest_mobile
        ? this.selectedTopUpCashCard.guest_mobile
        : "-";
    },
    POS_AMOUNT_CALCULATION_CHECK() {
      return this.$store.getters.POS_AMOUNT_CALCULATION_CHECK;
    },
    checkTicketTypeSelected() {
      let tempCount = 0;
      this.seatTypeOpenVoucher.map(x => {
        if (x.selected > 0) {
          tempCount += 1;
        }
      });
      if (tempCount > 0) {
        return true;
      } else {
        return false;
      }
    },
    calculateOpenVoucherPrice() {
      let amount = 0;
      this.seatTypeOpenVoucher.map(x => {
        amount += x.SinglePrice * x.selected;
      });
      return parseFloat(amount);
    },
    calculateOpenVoucherTTPrice() {
      let amount = 0;
      this.seatTypeOpenVoucher.map(x => {
        amount += parseFloat(x.VoucherAmount);
      });
      return parseFloat(amount);
    },
    openVoucherTotalGrossAmount() {
      return this.$store.getters.openVoucherTotalGrossAmount;
    },
    AREA_LANG_ID() {
      return this.$store.getters.AREA_LANG_ID;
    },
    RemainingCashRefundOfferAmount() {
      return this.$store.getters.RemainingCashRefundOffer;
    },
    currency() {
      return this.$store.getters.GET_CURRENCY;
    },
    CONTENT_LANG_ARRAY() {
      return this.$store.getters.CONTENT_LANG_ARRAY;
    },
    selectedContentLang() {
      return this.$store.getters.SELECTED_AREA_LANGUAGE;
    },
    seatTypeOpenVoucher() {
      return this.$store.getters.seatTypeArrayOpenVoucher;
    },
    seatType() {
      return this.$store.getters.SEAT_LAYOUT_DATA;
    },
    TicketTypePricingArray() {
      return this.$store.getters.newSeatLayoutArrayState;
    },
    checkRateCardGroupExist() {
      return this.$store.getters.isGroupExist;
    },
    checkCompleteRateCard() {
      return this.$store.getters.isCompleteRateCard;
    },
    offerApplied() {
      return this.$store.getters.getSelectedOffer;
    },
    movieDetails() {
      return this.$store.getters.MOVIE_DETAILS;
    },
    additionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    selectedDate() {
      return this.$store.getters.SELECTED_DATE;
    },
    dates() {
      return this.$store.getters.DATES;
    },
    showTimes() {
      return this.$store.getters.SHOW_TIMES;
    },
    allShowTimes() {
      return this.$store.getters.SHOW_TIMES;
    },
    visibleShowsDates() {
      return this.$store.getters.SHOW_DATES;
    },
    visibleShowsScreens() {
      return this.$store.getters.SHOW_SCREENS;
    },
    visibleShowsLanguage() {
      return this.$store.getters.SHOW_LANGUAGE;
    },
    groupedBySeatTypeSelectedSeats() {
      let selected_seats = this.$store.getters.SELECTED_SEATS;
      let selectedSeats = _.toPairs(
        _.groupBy(selected_seats.filter(x => x), "srt_id")
      );
      return selectedSeats;
    },
    selectedSeats() {
      return this.$store.getters.SELECTED_SEATS;
    },
    netTotal() {
      return this.$store.getters.NET_AMOUNT;
    },
    grossTotal() {
      return this.$store.getters.TOTAL_AMOUNT;
    },
    cashCardTopupAmount() {
      return this.$store.getters.getcashInputForCashCard;
    },
    cashCardTopupsection() {
      return this.$store.getters.getCashCardBalanceSection;
    },
    selectedTopUpCashCard() {
      return this.$store.getters.getSelectedTopUpCashCard;
    },
    custEmailCashCard() {
      return this.$store.getters.email_address
        ? this.$store.getters.email_address
        : this.$store.getters.customer_email_address
        ? this.$store.getters.customer_email_address
        : "";
    },
    offerPrice() {
      return this.getOfferPrice ? parseFloat(this.getOfferPrice).toFixed(2) : 0;
    },
    CashCardAmount() {
      return this.$store.getters.isCashCardDetail.hasOwnProperty("cardAmount")
        ? this.$store.getters.isCashCardDetail.cardAmount
        : 0;
    },
    fnbTotal() {
      return parseFloat(
        this.selectedFnBItemsTotalPrice + this.TotalAdditionalTaxes
      ).toFixed(2);
    },
    totalAmount() {
      return this.getOfferPrice > 0
        ? +parseFloat(
            this.$store.getters.TOTAL_AMOUNT +
              this.selectedFnBItemsTotalPrice +
              this.TotalAdditionalTaxes -
              this.getOfferPrice -
              parseFloat(this.CashCardAmount) - parseFloat(this.MeritCardAmount) - parseFloat(this.getSwapTotalAmount || 0)
          ).toFixed(2)
        : +parseFloat(
            this.$store.getters.TOTAL_AMOUNT +
              this.selectedFnBItemsTotalPrice +
              this.TotalAdditionalTaxes -
              parseFloat(this.CashCardAmount) - parseFloat(this.MeritCardAmount) - parseFloat(this.getSwapTotalAmount || 0)
          ).toFixed(2);
    },
    showDetails() {
      return this.$store.getters.SHOW_DETAILS;
    },
    currencyCode() {
      return this.currencyData["curr_code"]
        ? this.currencyData["curr_code"]
        : "";
    },
    allowPastBooking() {
      return this.secureStore.get("BGOAPB") || "N";
    },
    // POS OFFERS SAIF START
    ...mapGetters([
      "USE_TIM_INTEGRATION",
      "NEOLEAP_WEBSOCKET_URL",
      "USE_NEOLEAP_POS_PAYMENT",
      "getOffersCollection",
      "getOfferPrice",
      "getSelectedOffer",
      "getOffersVoucherCollection",
      "getOfferFor",
      "paymentModes",
      "selectedPaymentMode",
      "getAvailablePoints",
      "getBurnPoints",
      "isLoyaltyApplied",
      "getloyaltyAmount",
      "LoyaltyProgram",
      "isCashCardDetail",
      //
      "customer_mobile_number",
      "first_name",
      "last_name",
      "email_address",
      "cashCards",
      "selectedCashCard",
      "paid_amount",
      "paidflag",
      "disablePayNow",
      //
      "SelectedFnbItemList",
      "AdditionalTaxList",
      "RateCardAddonsChargesList",
      "RateCardAddonsChargesFinalAmount",
      "RateCardAddonsOnTicketChargeTypes",
      "isDataLoading",
      "getVoucherCode",
      "getTransactionComment",
      "getCustomerDetails",
      "getMovieLanguages",
      "getMovieFormats",
      "getMovieGenres",
      "getSwapRefundData",
      "getSwapNetAmount",
      "getSwapTotalAmount",
      "isSwap",
      "OPEN_OFFER_POPUP_AUTOMATICALLY"
    ]),
    ...mapState({
      promoCode: state => state.PosOffersStore.promocode,
      // voucherCode: state => state.PosOfferStore.voucherCode,
      selectedFnBItemsTotalPrice: state =>
        state.FnBStore.selectedFnBItemsTotalPrice,
      TotalAdditionalTaxes: state => state.FnBStore.totalAdditionalTaxes
    })
    // POS OFFERS SAIF END
  },
  methods: {
    moment,
     onCheckOfferAuth(response) {
        const { valid, name, user_id } = response;
        if (valid) {
          if (name == "posOfferAuth_pos_booking") {
            this.$bvModal.hide("posOfferAuth_pos_booking");
            this.$bvModal.show('addEmployeeDetails_pb')
          }
        }
      },
     onCheckEmployeeDetails(response) {
        const { valid, name } = response;
        if (valid) {
          if (name == "pos_booking") {
            this.employeeDetailsAuth = true;
            this.$bvModal.hide("addEmployeeDetails_pb");
            this.$bvModal.hide('posOfferAuth_pos_booking')
            this.onClickApplyOffer(this.tempSelectedOffer);
          }
        }
      },
    onClickApplyOffer(offerPayload) {
      const {event, offer, offerFor, booking_source_id, checkSpecificTitle} = offerPayload;
      if(offer.hasOwnProperty('is_employee_offer') && offer.is_employee_offer == 'Y') {
        this.tempSelectedOffer = _.cloneDeep(offerPayload);
        if(!this.employeeDetailsAuth) {
          this.onResetEmployeeDetails();
          this.$bvModal.hide('pos-applicable-offers')
          this.$bvModal.show('posOfferAuth_pos_booking')
        } else {
          this.applyOffersHandler({
            event: event,
            offer: offer,
            offerFor: offerFor,
            booking_source_id: booking_source_id,
            checkSpecificTitle: checkSpecificTitle
          })
          this.tempSelectedOffer = null;
          this.employeeDetailsAuth = false;
        }
      } else {
        this.applyOffersHandler({
          event: event,
          offer: offer,
          offerFor: offerFor,
          booking_source_id: booking_source_id,
          checkSpecificTitle: checkSpecificTitle
        })
      }
    },
    insertNeoleapLog(logFile) {
      let logObj = {
        user_id: this.secureStore.get("USINFO").user_id,
        user_name: this.secureStore.get("USINFO").username,
        cine_name: this.secureStore.get("USINFO").cine_name,
        reservation_id: this.reservationId,
        isTicket: 'Y',
        isFnb: 'N',
        data: logFile
      }

      if(backendSocket && backendSocket.connected) {
        console.log('NeoLeap Log Inserted');
        backendSocket.emit("generate-neoleap-log", logObj);
      } 
    },
    resetNeoleapManualData() {
      let tempObj = {
        StatusCode: "00",
        MerchantNameEnglish: "",
        MerchantNameArabic: "",
        MerchantAddress1English: "",
        MerchantAddress2English: "",
        MerchantAddress1Arabic: "",
        MerchantAddress2Arabic: "",
        download_phone: "",
        TransactionDateTime: "",
        TransacitonRequestDateTime: "",
        TransactionResponseDateTime: "",
        BankId: "",
        CardAcceptorIdCode: "   ",
        CardAcceptorTerminalId: "",
        TerminalVersion: "",
        CardAcceptorBusinessCode: "",
        TransactionSTAN: "",
        RetrievalReferenceNumber: "",
        CardSchemeID: "",
        CardNameArabic: "",
        CardNameEnglish: "",
        CardScheme: "",
        PrimaryAccountNumber: "",
        CardExpiryDate: "",
        TransactionTypeArabic: "",
        TransactionTypeEnglish: "PURCHASE",
        TransactionAmount: "",
        TransactionResponseEnglish: "NO RESPONSE",
        TransactionResponseArabic: "",
        TransactionResultReasonEnglish: "NO RESPONSE",
        TransactionResultReasonArabic: "",
        ResponseCodeDescription: "",
        TransactionAuthCode: "",
        TerminalModel: "",
        POSEntryMode: "MANUAL",
        TransactionResponse: "000",
        AID: "",
        TVR: "",
        TSI: "",
        CVMResult: "",
        CryptResult: "",
        ApplicationCryptogram: "",
        KID: "",
        ECRReferenceNumber: "",
      };
      Object.keys(tempObj).map((key) => {
        this.neoleapCardDetailsManual[key] = tempObj[key];
      })
    },
    neoleapManualCheckout() {
      this.$bvModal.hide('manualCardDetailsNeoleap');
      let amount = 0;
       if (this.neoPayType == 1) {
        amount = parseFloat(this.totalAmount - this.getloyaltyAmount).toFixed(
          2
        );
      } else if (this.neoPayType == 2) {
        amount = parseFloat(this.cashCardTopupAmount).toFixed(2);
      } else {
        amount = parseFloat(this.totalAmount - this.getloyaltyAmount).toFixed(
          2
        );
      }
      this.neoleapCardDetailsManual['TransactionAmount'] = amount
      this.neoleapCardDetailsManual['ECRReferenceNumber'] = this.neo_orderRef
      this.neoPaymentSuccessfull(this.neoleapCardDetailsManual);
    },
    onInputCardNumber(event) {
      let value = event.target.value;
      let maskNumber = this.maskCardNumber(value);
      this.neoleapCardDetailsManual.PrimaryAccountNumber = maskNumber;
    },
    maskCardNumber(cc, num = 4, mask = "*") {
      return (
        ("" + cc).slice(0, -num).replace(/./g, mask) + ("" + cc).slice(-num)
      );
    },
    _startNeoleapTimer() {
      let self = this;
      this.neoleapSkipTimer = setTimeout(() => {
        self.skipNeoleapResponse = 'Y';
      }, 70 * 1000);
    },
    proceedNeoleapManually(type) {
      this.$bvModal.show('manualCardDetailsNeoleap')
    },
    cancelNeoleapManually(type, showToast = true, message = '') {
      let toastMsg = message ? message : 'Transaction Cancelled'
      if(showToast) {
        this.$toasted.show(toastMsg);
      }
      this.skipNeoleapResponse = 'N';
      this.machineDisplay.processing = false;
    },
    checkHardwareId() {
      let hardwareId = localStorage.getItem("deiviceUniqueCode");
      let hardwareMacAddress = localStorage.getItem("hardware_mac_address");
      if(!hardwareId || !hardwareMacAddress) {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          if(backendSocket && backendSocket.connected) {
            console.log('PINGING HARDWARE FROM HOME PAGE');
            backendSocket.emit("hardware-connected");
          }
        }
      }
    },
    checkPaymentModeToShow(paymentMode) {
      if([12,13,17,10].includes(paymentMode.pm_id) && this.isSwap) {
        return false
      } else if(parseFloat(this.totalAmount - this.getloyaltyAmount) < 0 && [3,2].includes(paymentMode.pm_id)) {
        return false
      } else if([9].includes(paymentMode.pm_id)) {
         return false
      } else {
        return true
      }
    },
    rateCardAddonsChargeTypeToAdd(ct_id) {
      let result = 0;
      if (!ct_id) return result;

      result = this.RateCardAddonsOnTicketChargeTypes.filter(
        c => c.ct_id == ct_id
      )
        .map(c => c.final_value || 0)
        .reduce((prev, curr) => prev + curr, 0);
      return result || 0;
    },
    rateCardAddonsNetAdd() {
      let result = 0;
      result = this.RateCardAddonsOnTicketChargeTypes.map(
        c => c.net_value || 0
      ).reduce((prev, curr) => prev + curr, 0);

      return result;
    },
     getOfferDescription(offer, moreInfo = false) {
      let text = ``;
      if(offer.offer_type_id == 9) {
        if(moreInfo) {
          let offerCondition = offer.oc_max_no_of_ticket_per_transaction || '';
          if(offerCondition) {
          text += `Max Apply limit ${offerCondition}`
          }
        } else {
          text += `Buy ${offer.oc_buy_no_of_ticket} Ticket @ ${offer.oc_discount_value} Each.`
          let FNB_Criteria = []
          if(offer.oc_is_combo_with_fnb  == 'Y' && offer.fnb_group_data) {
            try {
              FNB_Criteria = offer.fnb_group_data ? JSON.parse(offer.fnb_group_data) : []
            } catch (err) {
              console.log('Error', err);
              FNB_Criteria = offer.fnb_group_data ? offer.fnb_group_data : []
            }
            if(FNB_Criteria.length > 0) {
            text += " Also Get" + FNB_Criteria.map(y => y.oc_buy_no_of_item + "x -" + y.selectedFnbItem.item_name + " @ " + this.currFormat(y.oc_fnb_at_price) + " Each.").join(", ")
            }
          } 
        }
        return text;
      } else if(offer.offer_type_id == 10) {
        if(moreInfo) {
          let offerCondition = offer.oc_max_no_of_ticket_per_transaction || '';
          if(offerCondition) {
            text += `Max Apply limit ${offerCondition}`
          }
        } else {
          text += `Buy ${offer.oc_buy_no_of_ticket} Ticket and Get ${offer.oc_discount_value_is_percentage == 'Y' ? '' : 'Flat'} ${offer.oc_discount_value} ${offer.oc_discount_value_is_percentage == 'Y' ? '%' : ''} OFF on another ticket.`
          return text;
        }
      }
    },
    releaseAllUnreservedSeats() {
      console.log("releasing seats");
      this.MAKE_SEAT_BOOKING_DETAILS_EMPTY();
      this.releaseRealtimeSeats();
    },
    creditPay(data) {
      if (data.status) {
        clearInterval(this.timTimeObj.timerInterval);
        // clearTimeout(this.creditTimeOut)
        if (data.data) {
          console.log("DATA.data creditPay", data.data);
          let trxobj = {
            trmTransRef: "",
            acqTransRef: "",
            sixTrxRefNum: "",
            cardholderName: "",
            cardNumber: "",
            cardNumberPrintable: "",
            cardRef: "",
            brandName: "",
            cardCountryCode: "",
            uid: "",
            aid: "",
            acc: ""
          };
          Object.keys(trxobj).map(key => {
            trxobj[key] = data.data[key];
          });
          this.$store.commit("SET_CREDIT_CARD_TRANSATION_DATA", trxobj);
          this.$store.commit("SET_CARD_GATEWAY_SERVICE", "TIM");
        }
        if (this.section.cashCardTopup) {
          this.onTopUpCashCard();
        } else {
          this.onClickPay();
        }
      }
      this.$toasted.show(data.message);
      this.machineDisplay.processing = false;
    },
    proceedCreditCard(type = 1) {
      if (
        typeof purchase == "function" &&
        localStorage.getItem("ECR_INIT_STATUS")
      ) {
        this.startTimTimer();
        if (type == 2) {
          //type == 2 for cashcard recharge
          this.machineDisplay.processing = true;
          let amount = parseFloat(this.cashCardTopupAmount).toFixed(2);
          purchase(amount, this.currencyData.curr_code);
        } else {
          //type == 1 for booking
          this.machineDisplay.processing = true;
          let amount = parseFloat(
            this.totalAmount - this.getloyaltyAmount
          ).toFixed(2);
          purchase(amount, this.currencyData.curr_code);
        }
      } else {
        this.machineDisplay.processing = false;
        this.$toasted.show("ECR Machine Not Active!");
      }
    },
    neoPaymentSuccessfull(responseData) {
      //Make Booking
      this.neo_orderRef = "";
      this.$store.commit(
        "SET_ALL_PAYMENT_CREDIT_CARD_TRANSATION_DATA",
        responseData
      );
      let nl_cardName = responseData.hasOwnProperty('CardNameEnglish') ? responseData['CardNameEnglish'] : null
      this.$store.commit("SET_CARD_GATEWAY_SERVICE", "NEOLEAP");
      this.$store.commit("SET_NL_CARD_NAME", nl_cardName);
      this.machineDisplay.processing = false;
      this.skipNeoleapResponse = 'N'
      this.neo_retry_count = 0;
      this.neo_click_count = 0;
      clearTimeout(this.neoleapSkipTimer);
      clearInterval(this.neoLeapTimeObj.timerInterval);
      console.log("Booking Processed!");
      if (this.section.cashCardTopup) {
        this.onTopUpCashCard();
      } else {
        this.onClickPay();
      }
    },
    onPayByGiftCard() {
      if (this.section.cashCardTopup) {
        this.onTopUpCashCard();
      } else {
        this.onClickPay();
      }
    },
    neoPaymentFailed(responseData, message = "") {
      this.machineDisplay.processing = false;
      this.skipNeoleapResponse = 'Y'
      clearTimeout(this.neoleapSkipTimer);
      clearInterval(this.neoLeapTimeObj.timerInterval);
      if (message) {
        this.$toasted.show(message);
      }
    },
    
    checkNeoLeapStatus() {
      this.startNeoLeapTimer();
      this.machineDisplay.processing = true;
      let checkObj = { Command: "CHECK_STATUS" };
      this.requestNeoLeap(JSON.stringify(checkObj));
    },
    connectNeoLeap(type) {
      this.createNeoleapWebSocket();
      this.neoPayType = type;
    },
    retryNeoTransaction() {
      this.neo_retry_count++;
      this.machineDisplay.processing = true;
      let lastTrxObj = { Command: "GET_LAST_TRX" };
      this.requestNeoLeap(JSON.stringify(lastTrxObj));
    },
    proceedNeoleap(type = 1) {
      // this.startNeoLeapTimer();
      this.machineDisplay.processing = true;
      let amount = 0;
      this.neo_orderRef = this.reservationId
        ? this.reservationId
        : generateRandomCode(8);
      if (this.neoPayType == 1) {
        amount = parseFloat(this.totalAmount - this.getloyaltyAmount).toFixed(
          2
        );
      } else if (this.neoPayType == 2) {
        amount = parseFloat(this.cashCardTopupAmount).toFixed(2);
      } else {
        amount = parseFloat(this.totalAmount - this.getloyaltyAmount).toFixed(
          2
        );
      }
      let paymentObj = {
        Command: "SALE",
        Amount: String(amount),
        Original_RRN: "",
        MaskedPAN: "",
        PrintFlag: "1",
        AdditionalData: String(this.neo_orderRef)
      };
      this.requestNeoLeap(JSON.stringify(paymentObj));
    },
    //Neoleap inTegration
    createNeoleapWebSocket() {
      let self = this;
      let WS_URL =
        this.NEOLEAP_WEBSOCKET_URL ||
        "wss://localhost:7000/neoleap_integration";
      this.neo_ws = new WebSocket(WS_URL);

      this.neo_ws.onopen = function() {
        // connection opened – add action here
        console.log("Connected");
        self.$toasted.show("Connected");
        self.checkNeoLeapStatus();
      };

      this.neo_ws.onmessage = function(evt) {
        console.log("onmessage evt", evt);
        if (evt.data) {
          let responseData = evt.data ? JSON.parse(evt.data) : "";
          self.insertNeoleapLog(responseData);
          console.log("responseData onmessage", responseData);

          if (
            !responseData.hasOwnProperty("EventName") &&
            !responseData.EventName &&
            responseData.hasOwnProperty("API_Status")
          ) {
            let errorMsg = `FAILED`;
            self.machineDisplay.processing = false;
            if(self.neo_click_count < 1) {
              self.skipNeoleapResponse = 'N'
              clearTimeout(self.neoleapSkipTimer);
              clearInterval(self.neoLeapTimeObj.timerInterval);
              self.neo_click_count++;
            } else {
              self.skipNeoleapResponse = 'Y'
              clearTimeout(self.neoleapSkipTimer);
              clearInterval(self.neoLeapTimeObj.timerInterval);
            }
            if (["2", "6"].includes(String(responseData.API_Status))) {
              if (self.neo_retry_count < 2) {
                self.retryNeoTransaction();
              } else {
                switch (responseData.API_Status) {
                  case "2":
                    errorMsg = `NO RESPONSE`;
                    break;
                  case "6":
                    errorMsg = `API TIMEOUT`;
                    break;
                  default:
                    errorMsg = `FAILED`;
                    break;
                }
                self.$toasted.show(errorMsg);
              }
            } else {
              switch (responseData.API_Status) {
                case "3":
                  errorMsg = `PORT ASSIGNED IS NOT PRESENT OR USED BY ANOTHER PROCESS.`;
                  break;
                case "4":
                  errorMsg = `UNEXPECTED ERROR OCCURRED, REQUEST CANCELLED`;
                  break;
                default:
                  errorMsg = `FAILED`;
                  break;
              }
              self.$toasted.show(errorMsg);
            }
            self.skipNeoleapResponse = 'Y'
          } else if (responseData.EventName == "TERMINAL_STATUS") {
            if (responseData.TerminalStatus == "READY") {
              self.proceedNeoleap(responseData);
            } else if (responseData.TerminalStatus == "BUSY") {
              self.neoPaymentFailed(
                responseData,
                "Terminal is " + responseData.TerminalStatus
              );
            } else {
              self.neoPaymentFailed(responseData, "Something Went Wring");
            }
          } else if (responseData.EventName == "TERMINAL_RESPONSE") {
            if (responseData.API_Status == "0") {
              if (
                responseData.hasOwnProperty("JsonResult") &&
                responseData.JsonResult
              ) {
                if (
                  responseData.JsonResult.StatusCode == "00" &&
                  responseData.JsonResult.TransactionTypeEnglish ==
                    "PURCHASE" &&
                  responseData.JsonResult.TransactionResponseEnglish ==
                    "APPROVED"
                ) {
                  if (
                    responseData.JsonResult.ECRReferenceNumber ==
                    self.neo_orderRef
                  ) {
                    self.$toasted.show(
                      responseData.JsonResult.TransactionResponseEnglish
                    );
                    self.neoPaymentSuccessfull(responseData.JsonResult);
                  } else {
                    self.neoPaymentFailed(
                      responseData,
                      "FAILED, PLEASE TRY AGAIN!"
                    );
                  }
                } else {
                  self.machineDisplay.processing = false;
                  self.skipNeoleapResponse = 'Y'
                  clearTimeout(self.neoleapSkipTimer);
                  clearInterval(self.neoLeapTimeObj.timerInterval);
                  self.$toasted.show(
                    responseData.JsonResult.TransactionResponseEnglish
                  );
                }
              } else {
                self.machineDisplay.processing = false;
                self.$toasted.show("No Response");
                // self.retryNeoTransaction()
              }
            } else {
              // self.retryNeoTransaction()
              self.neoPaymentFailed(responseData, "Failed");
            }
          } else if (responseData.EventName == "TERMINAL_ACTION") {
            console.log("SWIPE CARD");
          } else {
            self.machineDisplay.processing = false;
          }
        } else {
          self.insertNeoleapLog(evt);
          console.log("ELSE evt", evt);
        }
      };
      this.neo_ws.onerror = function(evt) {
        console.log("evt.message onerror", evt.message);
        self.skipNeoleapResponse = 'Y'
        clearTimeout(self.neoleapSkipTimer);
        clearInterval(self.neoLeapTimeObj.timerInterval);
        // error can be determined on evt.message
      };
      this.neo_ws.onclose = function() {
        console.log("Neo Leap Closed");
        // connection closed
      };
    },
    requestNeoLeap(jsonRequest) {
      if (this.neo_ws && this.neo_ws.readyState == WebSocket.OPEN) {
        console.log("requestNeoLeap jsonRequest", jsonRequest);
        var res = this.neo_ws.send(jsonRequest);
      } else {
        let e_msg = "Connection is Closed"
        this.neoPaymentFailed(null, e_msg)
        // this.$toasted.show("Connection is Closed " + this.neo_ws.readyState);
      }
    },
    disConnectNeoLeap() {
      this.neo_ws.close();
    },
    checkOfferType(offer) {
      let status = true;
      if (offer.offer_type_id == 3 && offer.oc_is_combo_with_fnb == "Y") {
        status = false;
      } else if(offer.offer_redeem_at_boxoffice == 'N') {
        status = false;
      }
      return status;
    },
    checkOpenOfferModal() {
      let status = true;
      let checkOfferPaymentMode = this.paymentModes.filter(
        x => x.pm_id == 12 || x.pm_id == 13
      );
      let offerArray = this.getOffersCollection.filter(offer =>
        this.checkOfferType(offer)
      );


      if (offerArray.length > 0 && checkOfferPaymentMode.length > 0) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },
    showNewOffersPopup(checkFlag = false) {
      if (checkFlag) {
        if (
          this.OPEN_OFFER_POPUP_AUTOMATICALLY == "Y" &&
          parseFloat(this.getOfferPrice).toFixed(2) == 0 &&
          this.checkOpenOfferModal()
        ) {
          this.$bvModal.show("promoOffersPopup");
        }
      } else {
        this.$bvModal.show("promoOffersPopup");
      }
    },
    onClickInputHandler(event) {
      if (
        Object.keys(this.keyboardsVisible).some(
          x => this.keyboardsVisible[x] == true
        )
      ) {
        Object.keys(this.keyboardsVisible).map(x => {
          if (x == event) {
            this.keyboardsVisible[x] = !this.keyboardsVisible[x];
          } else {
            this.keyboardsVisible[x] = false;
          }
        });
      }
    },
    async onIdlePOS() {
      console.log("CALLED yourFunction after idlelogout", this.screen_time);
      window.localStorage.setItem("LockedSinced", moment().format("HH:mm:ss"));
      window.localStorage.setItem("Locked", true);
      this.onLogout();
      // await this.$router.push({ path: "pos-lock-screen" });
      // location.reload();
    },
    getShowDetails(ShowDetails) {
      console.log("getShowDetails", ShowDetails);
    },
    onClickFilter(event, format) {
      this.selectedMovieFormatFilter = format.mf_id;
    },
    onToggleAddonBreakup() {
      this.showAddonBreakup = !this.showAddonBreakup;
    },
    seatTimeout() {
      console.log("seatTimeout Called 3860");
      this.$store.dispatch("MAKE_SEAT_BOOKING_DETAILS_EMPTY", {
        doNotShowError: false
      });
      this.$toasted.show("Seats Released");
      clearTimeout(this.seatReleasePopUp);
      clearTimeout(this.hideSeatExtendPopUp);
      clearTimeout(this.showSeatReleaseMsg);
      this.$bvModal.hide("extendSeatRelease");
      this.onClickCall("Refresh");
    },
    clearAllTimeouts() {
      clearTimeout(this.seatReleasePopUp);
      clearTimeout(this.hideSeatExtendPopUp);
      clearTimeout(this.showSeatReleaseMsg);
      this.$bvModal.hide("extendSeatRelease");
    },
    onShowSeatReleasePopUp() {
      if (this.POS_SEAT_ALERT_TIME_IN_SEC) {
        this.hideSeatExtendPopUp = setTimeout(() => {
          this.$bvModal.hide("extendSeatRelease");
        }, this.POS_SEAT_ALERT_TIME_IN_SEC * 1000);
      }
    },
    onHideSeatReleasePopUp() {
      clearTimeout(this.hideSeatExtendPopUp);
    },
    resetNeoLeapTimer() {
      this.neoLeapTimeObj.transactionTimeOut = `00:00`;
      this.neoLeapTimeObj.timePassed = 0;
      this.neoLeapTimeObj.timeLeft = 0;
      if (this.neoLeapTimeObj.timeInSec) {
        const minutes = Math.floor(this.neoLeapTimeObj.timeInSec / 60);
        let seconds = this.neoLeapTimeObj.timeInSec % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.neoLeapTimeObj.transactionTimeOut = `${minutes_n}:${seconds}`;
      } else {
        this.neoLeapTimeObj.transactionTimeOut = `00:00`;
      }
    },
    onNeoLeapTimeOut() {
      this.neoLeapTimeObj.transactionTimeOut = `00:00`;
      this.neoLeapTimeObj.timePassed = 0;
      this.neoLeapTimeObj.timeLeft = 0;
      this.neoLeapTimeObj.timeInSec = 60;
      clearInterval(this.neoLeapTimeObj.timerInterval);
      this.skipNeoleapResponse = 'Y';
      this.$forceUpdate();
    },
    startNeoLeapTimer() {
      clearInterval(this.neoLeapTimeObj.timerInterval);
      this.resetNeoLeapTimer();
      this.neoLeapTimeObj.timeLeft = this.neoLeapTimeObj.timeInSec;
      this.neoLeapTimeObj.timerInterval = setInterval(() => {
        this.neoLeapTimeObj.timePassed = this.neoLeapTimeObj.timePassed += 1;
        this.neoLeapTimeObj.timeLeft =
          this.neoLeapTimeObj.timeInSec - this.neoLeapTimeObj.timePassed;
        if (this.neoLeapTimeObj.timeLeft == 0) {
          this.onNeoLeapTimeOut();
        }
        const minutes = Math.floor(this.neoLeapTimeObj.timeLeft / 60);
        let seconds = this.neoLeapTimeObj.timeLeft % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.neoLeapTimeObj.transactionTimeOut = `${minutes_n}:${seconds}`;
      }, 1000);
    },
    startTimTimer() {
      clearInterval(this.timTimeObj.timerInterval);
      this.resetTimTimer();
      this.timTimeObj.timeLeft = this.timTimeObj.timeInSec;
      this.timTimeObj.timerInterval = setInterval(() => {
        this.timTimeObj.timePassed = this.timTimeObj.timePassed += 1;
        this.timTimeObj.timeLeft =
          this.timTimeObj.timeInSec - this.timTimeObj.timePassed;
        if (this.timTimeObj.timeLeft == 0) {
          this.onTransactionTimeOut();
        }
        const minutes = Math.floor(this.timTimeObj.timeLeft / 60);
        let seconds = this.timTimeObj.timeLeft % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.timTimeObj.transactionTimeOut = `${minutes_n}:${seconds}`;
      }, 1000);
    },
    resetTimTimer() {
      this.timTimeObj.transactionTimeOut = `00:00`;
      this.timTimeObj.timePassed = 0;
      this.timTimeObj.timeLeft = 0;
      if (this.timTimeObj.timeInSec) {
        const minutes = Math.floor(this.timTimeObj.timeInSec / 60);
        let seconds = this.timTimeObj.timeInSec % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.timTimeObj.transactionTimeOut = `${minutes_n}:${seconds}`;
      } else {
        this.timTimeObj.transactionTimeOut = `00:00`;
      }
    },
    onTransactionTimeOut() {
      this.timTimeObj.transactionTimeOut = `00:00`;
      this.timTimeObj.timePassed = 0;
      this.timTimeObj.timeLeft = 0;
      this.timTimeObj.timeInSec = 120;
      clearInterval(this.timTimeObj.timerInterval);
      if (typeof cancel == "function") {
        // this.$toasted.show('TimeOut!')
        cancel();
      }
      this.$forceUpdate();
    },
    timeLeftTimer() {
      this.resetSeatReleaseIn();
      this.timeLeft = this.POS_SEAT_ALERT_TIME_IN_SEC;
      this.timerInterval = setInterval(() => {
        this.timePassed = this.timePassed += 1;
        this.timeLeft = this.POS_SEAT_ALERT_TIME_IN_SEC - this.timePassed;
        if (this.timeLeft == 0) {
          this.onTimesUp();
        }
        const minutes = Math.floor(this.timeLeft / 60);
        let seconds = this.timeLeft % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.seatReleaseIn = `${minutes_n}:${seconds}`;
      }, 1000);
    },
    resetSeatReleaseIn() {
      if (this.POS_SEAT_ALERT_TIME_IN_SEC) {
        const minutes = Math.floor(this.POS_SEAT_ALERT_TIME_IN_SEC / 60);
        let seconds = this.POS_SEAT_ALERT_TIME_IN_SEC % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.seatReleaseIn = `${minutes_n}:${seconds}`;
      } else {
        this.seatReleaseIn = `00:00`;
      }
    },
    onTimesUp() {
      this.timePassed = 0;
      this.timeLeft = 0;
      clearInterval(this.timerInterval);
    },
    handleExtendSeatRelease() {
      let payload = {
        reservation_id: this.reservationId
      };
      MasterService.ExtendSeatReleaseTime(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.$bvModal.hide("extendSeatRelease");
            this.resetReleaseSeatPopUpTimer();
          } else {
            console.log("No status");
          }
        })
        .catch(err => {
          console.log("Error:", err);
        });
    },
    resetReleaseSeatPopUpTimer() {
      clearTimeout(this.seatReleasePopUp);
      clearTimeout(this.showSeatReleaseMsg);
      this.onTimesUp();
      if (this.POS_SEAT_EXTEND_TIMER && this.POS_SEAT_EXTEND_TIMER > 0) {
        console.log("Starting again the set release timer line 3800");
        this.seatReleasePopUp = setTimeout(() => {
          this.timeLeftTimer();
          if (this.showSeatExtendPopUp) {
            console.log("line 3871 TEST extendSeatRelease called");
            this.$bvModal.show("extendSeatRelease");
          }
        }, this.POS_SEAT_EXTEND_TIMER);
      }

      if (
        this.CINE_SEAT_RELEASE_TIME_IN_MINS &&
        this.CINE_SEAT_RELEASE_TIME_IN_MINS > 0
      ) {
        clearTimeout(this.showSeatReleaseMsg);
        this.showSeatReleaseMsg = setTimeout(() => {
          console.log("seatTimeout entended 3960");
          this.seatTimeout();
        }, this.CINE_SEAT_RELEASE_TIME_IN_MINS * 60 * 1000);
      }
    },
    onRemoveCashCard() {
      this.resetCashCardData();
      this.resetCustomerDetails();
    },
    onRemoveMeritGiftCard() {
      this.resetMeritCardDetails();
    },
    onClickAddMoney() {
      this.$root.$emit("bv::hide::modal", "addMoneyModal");
      this.onClickCall("cashCard");
      this.section.seatLayout = false;
      this.section.movieDetail = false;
      this.section.checkout = false;
      this.section.cashCardTopup = true;
      this.sectionHistory.push("checkout");
      this.removeClass = false;
      console.log("this.sections", this.section);
    },
    checkTopUpCashInput() {
      if (
        this.selectedPaymentMode.pm_id == 2 ||
        this.selectedPaymentMode.pm_id == 3
      ) {
        this.onTopUpCashCard();
      } else if (this.selectedPaymentMode.pm_id == 1) {
        if (this.POS_AMOUNT_CALCULATION_CHECK == "N") {
          this.onTopUpCashCard();
        } else if (
          parseFloat(this.$store.getters.CASH_INPUT) >=
          this.$store.getters.getcashInputForCashCard
        ) {
          this.onTopUpCashCard();
        } else {
          this.$toasted.show("Cash Input is less then Total Amount");
        }
      } else {
        this.$toasted.show("Please Select a Active Payment Mode");
      }
    },
    handleSubmit(e) {
      console.log(e);

      this.$refs.refund_cash_popup.hide();
    },
    checkEarliestBday(movieDetails) {
      let text = ``;
      if (
        movieDetails.hasOwnProperty("earliest_bday") &&
        movieDetails.earliest_bday
      ) {
        text = `${$t("earliest_bday")}`;
      }
    },
    onClickPay() {
      this.$refs.posFooterComponent.onClickCheckout();
    },
    sliceNumber() {
      this.open_ticket_discount_price = this.open_ticket_discount_price.slice(
        0,
        -1
      );
      this.totalofferDiscountov = parseInt(this.open_ticket_discount_price);
    },
    clearInput: function() {
      this.totalofferDiscountov = "";
      this.open_ticket_discount_price = "";
    },
    onClicknumber: function(index) {
      if (this.open_ticket_discount_price) {
        this.open_ticket_discount_price = String(this.totalofferDiscountov);
      } else {
        this.open_ticket_discount_price = "";
      }
      this.open_ticket_discount_price += this.keypadValues[index].name;
      this.totalofferDiscountov = parseInt(this.open_ticket_discount_price);
    },
    handleOpenModal() {
      this.$refs.totalofferDiscountov.focus();
    },
    handleOpenVoucherCodeModal() {
      // this.$refs.voucherCodemodal.focus();
    },
    handleRemainingPriceModal() {
      this.$refs.remainingOfferPrice.focus();
    },
    onRemoveOffer() {
      this.onResetOffersAndPrice();
      this.VoucherCodeDeounce = "";
    },
    onInputVoucherCode: _.debounce(function(event) {
      console.log("event", event);
      if (this.VoucherCodeDeounce) {
        this.onEnterVoucherCode({
         event: {
            target: {
              value: this.VoucherCodeDeounce
            }
          },
          name: "enterVoucherCode"
        });
        this.applyOffersHandler({
          event: null,
          offer: "",
          is_voucher_with_offers: true,
          offerFor: "vouchers",
          booking_source_id: 1
        });
      } else {
        this.onResetOffersAndPrice();
      }
    }, 1 * 1000),
    closeTotalDiscount() {
      this.totalofferDiscountov = "";
    },
    getTicketTypePrice(voucher) {
      let text = ``;
      if (voucher.hasOwnProperty("tt_id") && voucher.tt_id) {
        let checkValidation = true;
        if (voucher.hasOwnProperty("screen_id") && voucher.screen_id) {
          let Screen = this.TicketTypePricingArray.filter(
            x => x.screen_id == voucher.screen_id
          );
          if (Screen.length == 0) {
            checkValidation = false;
          }
        }
        let TicketType = this.TicketTypePricingArray.filter(
          x => x.tt_id == voucher.tt_id
        );

        if (TicketType && TicketType.length > 0 && checkValidation) {
          TicketType = _.orderBy(TicketType, ["total_amount"], ["asc"]);
          text = parseFloat(TicketType[0].total_amount).toFixed(2);
          return text;
        } else {
          return text;
        }
      } else {
        return text;
      }
    },
    clearVoucherCode() {
      this.voucherCodeValue = "";
    },
    applyTicketTypeOpenVoucher() {
      if (this.checkTicketTypeSelected) {
        this.applyOpenVoucher({
          amount: this.calculateOpenVoucherPrice
        });
      } else {
        return this.$toasted.show("Please Select Atleat One Ticket");
      }
    },
    checkOpenVoucherAmount() {
      if (this.totalofferDiscountov >= 0) {
        if (
          (this.openVoucherTotalGrossAmount >= this.totalofferDiscountov &&
            this.SELECTED_VOUCHER.is_allow_cash_refund == "N") ||
          this.SELECTED_VOUCHER.is_allow_cash_refund == "Y"
        ) {
          this.applyOpenVoucher({
            amount: this.totalofferDiscountov,
            voucher: {
              offer: this.SELECTED_VOUCHER,
              offerFor: "vouchers"
            }
          });
        } else {
          this.$toasted.show(
            "Voucher Discount cannot be more than total gross price"
          );
        }
      } else {
        this.$toasted.show("Please Enter a Valid Amount");
      }
    },
    checkOpenVoucherAmount_tt() {
      let errorCount = 0;
      let toatalAmount = 0;
      console.log("this.seatTypeOpenVoucher", this.seatTypeOpenVoucher);
      this.seatTypeOpenVoucher.map(x => {
        if (parseFloat(x.VoucherAmount) > parseFloat(x.totalOfferPrice)) {
          errorCount += 1;
          return this.$toasted.show(
            "Voucher Discount cannot be more than total gross price"
          );
        } else {
          toatalAmount += parseFloat(x.VoucherAmount);
        }
      });
      if (errorCount == 0) {
        this.applyOpenVoucher({
          amount: toatalAmount
        });
      }
    },
    checkVoucherDetails(OffersVoucherItem) {
      console.log("OffersVoucherItem TEST", OffersVoucherItem);
      this.selectedVoucherForVerifcation = OffersVoucherItem;
      if (OffersVoucherItem.is_code_required == "N") {
        let voucherCode = {
          target: {
            value: OffersVoucherItem.voucher_code
          }
        };
        this.onEnterVoucherCode({
          event: voucherCode,
          name: "enterVoucherCode"
        });
        this.applyOffersHandler({
          event: null,
          offer: OffersVoucherItem,
          offerFor: "vouchers",
          booking_source_id: 1
        });
      } else {
        this.$refs["verifyVoucher"].show();
      }
    },
    showSwapDetails() {
      this.childComponents.Swap = !this.childComponents.Swap;
    },
    onClick: function(type) {
      if (type == "cancel") {
        this.onResetOffersAndPrice();
        this.VoucherCodeDeounce = "";
        this.$refs.applicableOfferNotValid.hide();
      }
      if (type == "yes") {
        this.onResetOffersAndPrice();
        this.WithoutOffer = true;
        this.$refs.applicableOfferNotValid.hide();
      }
      if (type == "retry") {
        this.onResetOffersAndPrice();
        this.$refs.applicableOfferNotValid.hide();
        this.$bvModal.show("pos-applicable-offers");
      }
    },
    // POS OFFERS SAIF START
    ...mapActions([
      "fetchOffersVouchersList",
      "MAKE_SEAT_BOOKING_DETAILS_EMPTY",
      "releaseRealtimeSeats",
      "onChangeAreaLanguage",
      "set_dropdown_area_language",
      "onSelectVoucher",
      "onSetSelectedOfferId",
      "onSetOffersFlags",
      "onEnterPromoCodes",
      "onEnterVoucherCode",
      "onInputComment",
      "applyOffersHandler",
      "onResetOffersAndPrice",
      "setPaymentMode",
      "onApplyLoyalty",
      "resetLoyaltyData",
      "selectCashCard",
      "payCashCard",
      "onRemoveFnBList",
      "setPosFooterMenus",
      "applyFilter",
      "clearFilter",
      "fetchMovieLanguages",
      "fetchMovieGenre",
      "fetchMovieFormats",
      "fetchAllShows",
      "onResetSwapInfo",
      "fetchFnBItems",
      "SetCinemaId",
      "changeCountHandlerOpenVoucher",
      "applyDiscountAmount",
      "applyOpenVoucher",
      "onEnterVoucherAmount",
      "onClickVoucherBox",
      "onTopUpCashCard",
      "TOPUP_COMPLETE",
      "resetCashCardData",
      "resetCustomerDetails",
      "resetMeritCardDetails",
      "onResetEmployeeDetails"
    ]),
    onApplyVoucherBox(voucher) {
      this.onClickVoucherBox(voucher);
      this.selectedVoucherForVerifcation = voucher;
      this.onSelectVoucher(voucher);
    },
    updateCardNumber(e) {
      this.$store.commit("SET_CARD_NUMBER", { title: e.target.value });
    },
    timeSinceShowElapsed(showTime, showDate, cutoffTime) {
      let movie_showtime = moment(
        moment(showDate).format("YYYY-MM-DD") + " " + showTime,
        "YYYY-MM-DD HH:mm"
      );
      var show_date_with_cutoff =
        movie_showtime.valueOf() + cutoffTime * 60 * 1000;
      // var dateTime = moment(show_date_with_cutoff).format("YYYY-MM-DD HH:mm");
      var currentTime = moment().valueOf();

      if (currentTime >= show_date_with_cutoff) {
        return false;
      } else {
        return true;
      }
      // var endTime = moment(currentTime, "YYYY-MM-DD HH:mm");
      // var duration = moment.duration(endTime.diff(dateTime));
      // var hours = parseInt(duration.asHours());
      // var minutes = parseInt(duration.asMinutes());
      // console.log("hours :>> ", hours, minutes, showDate);

      // let a = currentTime
      //   .split(" ")
      //   .join()
      //   .split(":");
      // console.log("a :>> ", a);
      // let currentHours = a[1];

      // if (hours >= 0 && minutes >= cutoffTime) {
      //   return false;
      // } else {
      //   return true;
      // }

      // var show_date = moment(showDate).format("YYYY-MM-DD");
      // var startTime = moment(show_date + " " + showTime, "YYYY-MM-DD HH:mm");
      // var currentTime = moment().format("YYYY-MM-DD HH:mm");
      // var endTime = moment(currentTime, "YYYY-MM-DD HH:mm");
      // var duration = moment.duration(endTime.diff(startTime));
      // var hours = parseInt(duration.asHours());
      // if (hours > 1) {
      //   return false;
      // } else {
      //   return true;
      // }
      // return hours;
    },
    idleLogout: function() {
      let self = this;
      //var t;
      // console.log("window.onmousemove :", window.onmousemove);
      // console.log("resetTimer :", resetTimer);
      window.onload = resetTimer;
      window.onmousemove = resetTimer;
      window.onmousedown = resetTimer; // catches touchscreen presses as well
      window.ontouchstart = resetTimer; // catches touchscreen swipes as well
      window.onclick = resetTimer; // catches touchpad clicks as well
      window.onkeypress = resetTimer;
      window.addEventListener("scroll", resetTimer, true); // improved; see comments
      async function yourFunction() {
        window.localStorage.setItem(
          "LockedSinced",
          moment().format("HH:mm:ss")
        );
        window.localStorage.setItem("Locked", true);
        self.$router.push({ path: "pos-lock-screen" });
        location.reload();
        // this.$forceUpdate();
        // your function for too long inactivity goes here
        // e.g. window.location.href = 'logout.php';
        // window.location.href = "pos-lock-screen";
      }
      function resetTimer() {
        clearTimeout(self.screen_lock_time);
        // console.log("self.screen_lock_time :", self.screen_lock_time);
        if (this.screen_time) {
          self.screen_lock_time = setTimeout(yourFunction, this.screen_time); // time is in milliseconds
        } else {
          self.screen_lock_time = setTimeout(yourFunction, 60 * 1000 * 30); // time is in milliseconds
        }
        // clearTimeout(self.screen_lock_time);
      }
    },
    getGlobalOptions: async function() {
      if(this.$store.getters.getGlobalOptions && this.$store.getters.getGlobalOptions.length > 0) {
        this.$store.getters.getGlobalOptions.map(x => {
              if (x.go_key === "POS_LOCK_SCREEN_TIME") {
                this.screen_time = x.go_value;
              }
              if (x.go_key === "REVERSE_SEAT_LAYOUT") {
                this.reverse_screen = x.go_value == "Y";
              }
            });
      } else {
        MasterService.GetGlobalOptions()
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              data.Records.map(x => {
                if (x.go_key === "POS_LOCK_SCREEN_TIME") {
                  this.screen_time = x.go_value;
                }
                if (x.go_key === "REVERSE_SEAT_LAYOUT") {
                  this.reverse_screen = x.go_value == "Y";
                }
              });
            } 
          })
          .catch(error => {
            console.log("catch error on GetGlobalOptions :", error);
          });
      }
    },

    // POS OFFERS SAIF END
    getSortArrayHere: function(data) {
      return _.sortBy(data, ["ss_actual_start_date_time"]);
    },
    onApplyOffer: function(offer) {
      //check no of ticket
      if (offer.offer_type_id == 6) {
        if (this.promocode.length > 0) {
          if (offer.promo_code == this.promocode) {
            this.$store.dispatch("SET_TOTAL_AMOUNT", offer);
            this.$refs["applicable-offer-modal"].hide();
          } else {
            this.$toasted.show("Not a valid promocode");
          }
        } else {
          this.$toasted.show("Please Enter Promocode");
        }
      } else {
        if (offer.oc_is_combo == "Y" && offer.oc_is_combo_with_fnb == "Y") {
          this.$toasted.show("Offer is applicable on Fnb");
        } else {
          if (
            this.selectedSeats.length >=
            offer.oc_buy_no_of_ticket + offer.oc_get_free_ticket
          ) {
            if (
              offer.offer_applicable_on_gross_amount == "Y" &&
              offer.oc_min_ticket_price &&
              parseFloat(this.totalAmount) >=
                parseFloat(offer.oc_min_ticket_price)
            ) {
              //apply offer
              this.$store.dispatch("SET_TOTAL_AMOUNT", offer);
              this.$refs["applicable-offer-modal"].hide();
            } else if (
              offer.offer_applicable_on_net_amount == "Y" &&
              offer.oc_min_ticket_price &&
              parseFloat(this.netTotal) >= parseFloat(offer.oc_min_ticket_price)
            ) {
              //apply offer
              this.$refs["applicable-offer-modal"].hide();
              this.$store.dispatch("SET_TOTAL_AMOUNT", offer);
            } else if (offer.offer_applicable_on_gross_amount == "Y") {
              //apply offer
              this.$store.dispatch("SET_TOTAL_AMOUNT", offer);
              this.$refs["applicable-offer-modal"].hide();
            }
          } else {
            this.$toasted.show(
              "Please select atleast " +
                (offer.oc_buy_no_of_ticket + offer.oc_get_free_ticket) +
                " ticket(s)"
            );
          }
        }
      }
    },
    getCinemaSettings: function(cinema_id) {
      let payload = {
        cinema_id
      };
      MasterService.GetCinemaSettings(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.$store.commit("SET_CINEMA_SEAT_SETTINGS", data.Records);
          } else {
            console.log("Error:", data.message);
          }
        })
        .catch(err => {
          this.$toasted.show(err);
        });
    },
    getCurrencyCode: function() {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
            this.$store.dispatch("SAVE_CURRENCY", this.currencyData.curr_code);
            this.$store.commit("GLOBAL_CURR_ID", this.currencyData.curr_id);
          } else {
            // Show Error Message:
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    onChangeTab: function(event) {
      this.selectedTabIndex = event;
    },
    onChangeFilter: function(event, name) {
      this.selectedFilterName = name;
    },

    onClickMovieModal(movie_id, md_id) {
      let payload = {
        movie_id,
        md_id
      };
      this.$store.dispatch("GET_MOVIE_DETAILS", payload);
    },
    onSearch() {
      this.$store.dispatch("SEARCH", this.searchValue);
    },
    applyFilters() {
      this.applyFilter({
        type: "language",
        payload: this.selectedMovieLanguageFilter
      });
      this.applyFilter({
        type: "format",
        payload: this.selectedMovieFormatFilter
      });
      this.applyFilter({
        type: "genre",
        payload: this.selectedMovieGenreFilter
      });
      this.fetchAllShows();
      this.$refs.selectFormat.hide();
    },
    filterShows: function(format) {
      this.$refs.selectFormat.hide();
      this.$store.dispatch("FILTER_FORMAT", format);
    },
    getFormatList: function() {
      this.Formats = [];
      let body = this.getRequestBody("GET", undefined, this.FormatMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Formats = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    closeModal: function() {
      this.childComponents.PosSchedule = false;
    },
    showFullScreen: function() {
      this.fullscreen = !this.fullscreen;
      if (this.$socket) {
        this.$socket.emit(
          "main_brij_flag_change",
          this.fullscreen,
          this.currencyData.curr_code
        );
      }

      // if (this.$socket) {
      //   this.$socket.emit("main_brij_flag_change", this.fullscreen);
      // }
    },
    onCloseModal: function(modalName) {
      this.$refs[modalName].hide();
    },
    onClickCall: async function(name, flag) {
      if (name == "Refresh") {
         this.section = {
          // login: false,
          movieDetail: true,
          seatLayout: false,
          checkout: false,
          cashCardTopup: false
        };

        this.$store.dispatch("GET_DATES");

        this.getGlobalOptions();
        this.clearAllTimeouts();
        this.$store.dispatch("releaseRealtimeSeats");
        this.$store.dispatch("MAKE_SEAT_BOOKING_DETAILS_EMPTY");
        this.$store.dispatch("onResetFnBStoreState");
        this.$store.dispatch("onResetEmployeeDetails");
        this.$store.dispatch("MAKE_DATA_EMPTY");
        this.$store.dispatch("ResetCardTrxDetails");

        // this.section = {
        //   // login: false,
        //   movieDetail: true,
        //   seatLayout: false,
        //   checkout: false,
        //   cashCardTopup: false
        // };

        Object.keys(this.childComponents).map(x => {
          this.childComponents[x] = false;
        });

        this.currentTime = Math.round(new Date().getTime() / 1000); //Unix Timestamp in Seconds;

        // this.$store.dispatch("GET_DATES");
        this.getFormatList();
        let obj = this.secureStore.get("USINFO").cinema_id;
        this.getCurrencyCode();
        // this._GetGlobalOptions()
        //   .then(() => {
        //     this.getCurrencyCode();
        //   })
        //   .catch(error => {
        //     this.$toasted.show("Error while fetching global options " + error);
        //   });
      } else {
        console.log("name :>> ", name);
        Object.keys(this.childComponents).map(x => {
          if (x == name) {
            this.childComponents[x] = !this.childComponents[x];
          } else {
            this.childComponents[x] = false;
          }
        });
      }
      if (this.timTimeObj.timerInterval) {
        this.onTransactionTimeOut();
      }
    },
    onClickCloseButton: function() {
      this.$store.dispatch("onResetDateStoreState");
      this.$store.dispatch("MAKE_DATA_EMPTY");
      this.$store.dispatch("onCloseClearIDsforBoxOffice");
      this.$store.dispatch("onCloseClearIDsforFnb");
      this.$store.dispatch("onResetOffersStoreState");
      this.$store.dispatch("resetCashCardData");
      this.$store.dispatch("ResetCardTrxDetails");
      this.$store.dispatch("CLEAR_CARD_NUMBER", null);
      //
      this.$store.dispatch("onResetFnBStoreState");

      this.onClickCall();
      this.sectionHistory = [];
      this.section = {
        // login: false,
        movieDetail: true,
        seatLayout: false,
        checkout: false,
        cashCardTopup: false
      };
      // this.$store.dispatch("onChangeFlag", {
      //   // login: false,
      //   movieDetail: true,
      //   seatLayout: false,
      //   checkout: false
      // });
    },
     onLogout: function() {
      UserService.removeToken()
        .then(res => {
          const { data } = res;
          if (data.status == true) {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/pos-login" });
            this.$cookie.delete("BRHSID");
          } else {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/pos-login" });
            this.$cookie.delete("BRHSID");
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$router.push({ path: "/pos-login" });
          this.$toasted.show("Token not removed");
        });
    },
    onClickShow(showDetails, showTime) {
      // console.log('showTime', showTime);
      // console.log('showDetails', showDetails);
      
      if(this.validateShowCinema(showDetails.cine_id)) {
      this.showTime_seatlayout_details = {
        screen_id: showTime.screen_id,
        ss_id: showTime.ss_id,
        md_id: showTime.md_id
      };
      // this.$store.dispatch("onSetAndSendLog", {
      //   action: `Selected movie :${showDetails.movie_title}  for screen :${
      //     showDetails.screen_name
      //   } for date and time:${moment(showTime.ss_start_date).format(
      //     "DD-MM-YYYY"
      //   )} ${showTime.ss_start_show_time} and has schedule id : ${
      //     showTime.ss_id
      //   }`,
      //   page_name: "POS booking",
      //   api_name: window.location.hash
      // });
      // POS OFFERS START
      // console.log(
      //   "showTime.ss_start_date_time :>> ",
      //   showTime.ss_start_date_time
      // );
      // console.log('showTime>>>>', showTime);
      let show_actual_date_time = moment(moment(showTime.ss_actual_start_date, 'YYYY-MM-DD').format('YYYY-MM-DD') + ' ' + moment(showTime.ss_start_show_time, 'HH:mm').format('HH:mm')).valueOf()
      this.onSetSelectedOfferId({
        name: "isMovie_isScreen_isShowTime",
        screen_id: showTime.screen_id,
        movie_details_id: showTime.md_id,
        // show_date_time: moment.unix(showTime.ss_start_date_time).format(),
        show_date_time: showTime.ss_start_date_time,
        show_actual_date_time: show_actual_date_time,
      });
      // POS OFFERS END

      this.$store.dispatch("GET_SEAT_LAYOUT", {
        screen_id: showTime.screen_id,
        ss_id: showTime.ss_id,
        md_id: showTime.md_id
      });

      // console.log(
      //   "🚀 ~ file: posBooking.vue ~ line 2932 ~ onClickShow ~ showTime.ss_id",
      //   showTime.ss_id
      // );

      this.selected_ssid = showTime.ss_id;
      this.turnOffMultiSeatSelection = showTime.turnOffMultiSeatSelection;

      //emit socket for external display
      let token = window.localStorage.getItem("JWT_TOKEN");
      if (this.$socket) {
        this.$socket.emit("set_seat_layout_data", {
          screen_id: showTime.screen_id,
          JWT_TOKEN: token,
          ss_id: showTime.ss_id,
          md_id: showTime.md_id,
          reverse: this.reverse_screen
        });
      }

      // // console.log("showDetails :", showDetails);
      this.$store.dispatch("SAVE_SHOW_DETAILS", {
        // ...showDetails,
        ...showTime,
        actualDate: showDetails.ss_start_date
      });
      this.removeClass = false;
      this.section.movieDetail = false;
      this.section.seatLayout = true;
      if (this.sectionHistory.length === 0) {
        this.sectionHistory.push("movieDetail");
        this.sectionHistory.push("seatLayout");
      } else {
        this.sectionHistory.push("seatLayout");
      }
      // this.$router.push({
      //   path: "pos-seatlayout"
      // });
      } else {
        console.log('CINEMA NOT MATCHED ACCESS DENIED');
        this.$toasted.show('Token Expired')
        this.onLogout();
      }
    },
    onClickSeat() {
      this.section.seatLayout = false;
      this.section.movieDetail = false;
      this.section.cashCardTopup = false;
      this.section.checkout = true;
      setTimeout(() => {
        this.showNewOffersPopup(true);
      }, 500);
      this.sectionHistory.push("checkout");
      this.removeClass = false;
    },
    onUnpaidBookingCancel: function() {
      this.section.seatLayout = false;
      this.section.movieDetail = true;
      this.section.checkout = false;
      this.section.cashCardTopup = false;
      this.sectionHistory = [];
      this.sectionHistory.push("movieDetail");
      this.removeClass = false;
    },
    onBackHandler: function() {
      this.VoucherCodeDeounce = "";
      this.onInputComment({ target: { value: "" } });
      console.log("this.sectionHistory :>> ", this.sectionHistory);
      if (this.sectionHistory.length > 1) {
        let length = this.sectionHistory.length;
        let name = this.sectionHistory[length - 1];
        let secondname = this.sectionHistory[length - 2];
        this.section[name] = !this.section[name];
        this.section[secondname] = !this.section[secondname];
        this.sectionHistory.pop();
        // this.$store.dispatch("onSetAndSendLog", {
        //   action: `Went back From ${name} page to ${secondname} page`,
        //   page_name: "POS booking",
        //   api_name: window.location.hash
        // });

        if (this.section.seatLayout) {
          // SHOW_DETAILS:Object

          // this.$store.getters.SHOW_DETAILS;
          // console.log(
          //   "this.$store.getters.SHOW_DETAILS :",
          //   this.$store.getters.SHOW_TIMES
          // );
          // let payload = {
          //   screen_id: this.$store.getters.SHOW_DETAILS.screen_id || null,
          //   ss_id: this.$store.getters.SHOW_DETAILS.ss_id || null,
          //   md_id: this.$store.getters.SHOW_DETAILS.md_id || null
          // }; //Previous Code which giving another screen_id on Back Button from Generate Bill to Seat Layout

          let payload = {
            screen_id: this.showTime_seatlayout_details.screen_id || null,
            ss_id: this.showTime_seatlayout_details.ss_id || null,
            md_id: this.showTime_seatlayout_details.md_id || null
          };
          if (payload.screen_id && payload.ss_id && payload.md_id) {
            this.$store.dispatch("GET_SEAT_LAYOUT", payload);
          }
        }
        if (this.timTimeObj.timerInterval) {
          this.onTransactionTimeOut();
        }
      }
    },

    onSelectPaymentType: function(name) {
      console.log("onSelectPaymentType", name);
      if (name.payment_mode_id == 13 && this.isLoyaltyApplied) {
        this.$toasted.show("Loyality Applied. You will not get offers");
        return false;
      }

      if ([2, 3].includes(name.payment_mode_id)) {
        if (this.USE_NEOLEAP_POS_PAYMENT == "Y") {
          console.log("calling neoleap");
          // this.createNeoleapWebSocket();
          this.machineDisplay.processing = false
          this.skipNeoleapResponse = 'N'
          this.resetNeoleapManualData();
          clearTimeout(this.neoleapSkipTimer);
          clearInterval(this.neoLeapTimeObj.timerInterval);
          this.neo_retry_count = 0;
          this.neo_click_count = 0;
          this.resetNeoLeapTimer();
        }
      }

      if (
        ![2, 3].includes(name.payment_mode_id) &&
        this.machineDisplay.processing &&
        this.USE_TIM_INTEGRATION == "Y"
      ) {
        if (typeof cancel == "function") {
          cancel();
        }
        this.onTransactionTimeOut();
      }

      // this.$store.dispatch("SET_CASH_INPUT", 0);
      if (['GiftCard'].includes(String(name.payment_mode_id))) {
        console.log('COMING HERE LINE 6117', name.payment_mode_id);
        if (this.giftCardsPaymentModes && this.giftCardsPaymentModes.length > 0) {
          this.setPaymentMode(this.giftCardsPaymentModes[0]);
        }
      } else {
        this.setPaymentMode(name);
      }
      // this.paymentTypes[name] =true
      // Object.keys(this.paymentTypes).map(x => {
      //   // console.log('x :', x);
      //   if (x == name) {
      //     this.paymentTypes[x] = this.paymentTypes[x]
      //       ? this.paymentTypes[x]
      //       : !this.paymentTypes[x];
      //   } else {
      //     this.paymentTypes[x] = false;
      //   }
      // });
    },

    closeApplicableOffersModal: function() {
      this.$refs["applicable-offer-modal"].hide();
    }
  }
};
</script>
<style>
.listed-movie-time-list li.disabled {
  border-color: #d3d3d3;
  color: #fff;
  background: #d3d3d3;
  pointer-events: none;
  cursor: default;
}

.btn_min_width_190 {
  min-width: 190px
}

.circle {
  border-radius: 50%;
  width: 1px;
  height: 15px;
  padding: 3px 4px;
  background: #fff;
  border: 1px solid #000;
  color: #000;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.al_dropdown button {
  font-size: 0.84rem;
  line-height: 1;
}

.avail {
  color: green;
}
#listed-movie-synopsis .btn-modal-close {
  top: -10px !important;
  right: -21px !important;
}

.no-padding {
  padding: 0px !important;
}

.search-input {
  /* top: 2.5px; */
  /* top: 0; */
  /* height: 55px; */
  /* font-size: 14px; */
  /* position: absolute; */
  /* width: 25%; */
  /*flex: 0 0 35%;*/
  min-width: 200px;
  /* left: 527px; */
}

.search-input .form-control {
  /* height: 45px; */
  height: 45px;
  /* border-radius: 20px; */
  border-radius: 50rem;
  font-size: 14px;
  width: 100%;
}
/* .pos-menus-hidden {
  top: -156px;
  height: 167px;
} */

/* .pos-modal-close {
  top: -11px !important;
    right: -30px !important;
} */

.viewSwap {
  cursor: pointer;
  text-decoration: underline;
}
</style>
<style scoped>
/*@media (min-width: 992px) {*/

/* .seat_select_modal .modal-lg{*/
/*  max-width: 1030px;*/
/*  background-color: white;*/
/*  } */

/*}*/

.w-150 {
  min-width: 150px;
}

.seat-type {
  padding: 1rem;
  min-width: 200px;
  height: 115px;
  font-weight: bold;
}

#showRateCardPrice .seat-type {
  width: 280px !important;
}

.seat-type.gold {
  background-color: #fcf4d9;
  color: #f2c94c;
}

.seat-type.silver {
  background-color: #efefef;
  color: #a8a8a8;
}

.seat-type .st-name {
  font-weight: bold;
  font-size: 2.5rem;
  border-bottom: 1px solid #bfbfbf;
  line-height: 1;
  margin-bottom: 0.25rem;
  word-break: break-all;
}
#showRateCardPrice .category {
  width: 240px !important;
}

#showRateCardPrice .category .category-name {
  word-break: break-all;
}
.category {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 160px;
  background-color: #efefef;
  color: black;
  text-align: center;
  margin: 1rem;
  border-radius: 0.5rem;
}
.category.disabled {
  background-color: #f9f9f9;
  color: #999999;
}
.category.disabled .mod-btn {
  background-color: #afc8ed;
}
.category .category-name {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.category .category-price {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.category .category-seats {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: 1px solid #bfbfbf;
  padding: 0.25rem;
  width: 100%;
  color: black;
  user-select: none;
}
.category .category-seats .mod-btn {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  color: white;
  background-color: #3876d2;
  height: 40px;
  width: 40px;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.4s;
}
.category .category-seats .mod-btn:hover {
  color: #3876d2;
  background-color: white;
}
.category .category-seats .mod-btn:active,
.category .category-seats .mod-btn.active {
  transform: scale(0.8);
}

.category .category-seats .mod-btn.disabled,
.btn-submit-disabled {
  background-color: lightgrey;
  pointer-events: none;
}

.fl.btn-blue {
  font-size: 20px !important;
  padding: 1.5rem 2rem;
}

.currency-symbol {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 12px;
  transform: translateY(-50%);
}
.InputAmount {
  padding-right: 3rem !important;
}
.noFnbItem {
  font-size: 13px;
}
.no-fnb-btn {
  background-color: white !important;
  color: red !important;
  border-color: red !important;
}
.status-dot {
  display: inline-block;
  margin-left: 6px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: var(--success);
}
.nfs-17 {
  font-size: 17px !important;
}

.voucher-box {
  height: 114px;
  margin: 22px;
  width: 40px;
  background: lightgray;
  border-radius: 10px;
}
.voucher_btn {
  background-color: var(--blue);
  color: white;
  border: 1px solid transparent;
  border-radius: 12px;
  /* padding: 16px; */
  padding: 8px;
  text-align: center;
  /* margin-bottom: 24px; */
  margin-bottom: 16px;
  line-height: 1.2;
  cursor: pointer;
  transition: border-color 0.5s, transform 0.5s, background-color 0.5s,
    color 0.5s;
  display: flex;
  flex-flow: column nowrap;
  /* height: 125px; */
  height: 80px;
  justify-content: center;
  align-items: center;
}

.voucher_btn:active {
  transform: scale(0.9);
}

.voucher_btn:active,
.voucher_btn.active,
.voucher_btn:hover {
  background-color: white;
  box-shadow: 0px 2px 6px -1px;
  color: var(--blue);
  border-color: var(--blue);
}
.giftcard_input {
  min-height: 175px;
}

.voucher_btn.inactive {
  /* background-color: grey;
  cursor: default;
  pointer-events: none;
  opacity: 0.2; */
  background-color: lightgray;
  cursor: default;
  pointer-events: none;
  opacity: 0.3;
  color: black;
}

.voucher_btn .voucher_btn__name > p {
  font-size: 18px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* -webkit-line-clamp: 2; */
  -webkit-line-clamp: 1;
  margin-bottom: 0;
}

.voucher_btn .voucher_btn__screen > p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.voucher_btn .voucher_btn__time > p {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.voucher_btn .voucher_btn__details {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.voucher_btn .voucher_btn__name + .voucher_btn__details {
  margin-top: 4px;
}

.voucher_btn .voucher_btn__details > div:nth-last-child(2) {
  max-width: 65%;
}

.voucher_btn .voucher_btn__details > div:nth-child(2) {
  margin-left: 12px;
}

.voucher_btn_row > article.col-6:nth-child(odd) {
  padding-right: 8px;
}

.voucher_btn_row > article.col-6:nth-child(even) {
  padding-right: 8px;
}
.pm_disbaled {
  opacity: 0.5;
  pointer-events: none;
}
.pos_booking_input_material .input-material input:focus + label,
.pos_booking_input_material
  .input-material
  input:not(:placeholder-shown)
  + label,
.pos_booking_input_material
  .input-material
  textarea:not(:placeholder-shown)
  + label,
.pos_booking_input_material
  .input-material-textarea
  textarea:not(:placeholder-shown)
  + label,
.pos_booking_input_material .input-material input.is_active + label {
  left: 36px;
  top: -5px;
  background-color: #fff;
  color: var(--blue);
  font-size: 12px;
}

.pos_booking_input_material .input-material input.is_active {
  color: #495057;
  background-color: #fff;
  /* border-color: #80bdff; */
  outline: 0;
  /* -webkit-box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%); */
  /* box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%); */
}

.pos_booking_input_material .input-material input + label,
.input-material textarea + label,
.input-material-textarea textarea + label {
  top: 18px;
  left: 36px;
}
.word-break{
  word-break: break-all;
}
@media screen and (min-width: 578px) and (max-width: 768px) {
  .img_height {
    height: 20vh;
  }
}
@media screen and (min-width: 769px) and (max-width: 991px) {
  .img_height {
    height: 20vh;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .img_height {
    height: 21vh;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1400px) {
  .img_height {
    height: 20vh;
  }
}

@media screen and (min-width: 1401px) and (max-width: 1600px) {
  .img_height {
    height: 20vh;
  }
}
@media (max-width: 1200px) {
  .pos-movie-listing-wrapper .btn-blue-lg {
    height: 40px !important;
    font-size: 12px;
  }

  .search-input .form-control {
    height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posBooking.vue